import { openBlock as k, createElementBlock as H, createElementVNode as fe, unref as v, reactive as Vt, computed as z, ref as ee, toRef as en, watch as mt, h as qa, render as Xn, defineComponent as Ie, renderSlot as re, createCommentVNode as j, normalizeClass as we, withKeys as ce, createBlock as pe, withModifiers as De, onMounted as ze, normalizeStyle as Je, normalizeProps as _e, mergeProps as Ne, Fragment as ye, createTextVNode as st, toDisplayString as Be, onBeforeUpdate as Za, nextTick as gt, onUnmounted as Yn, renderList as Ae, withDirectives as Qt, vShow as Xt, withCtx as ge, createVNode as Ge, Transition as Rt, createSlots as Ue, useSlots as Mt, guardReactiveProps as Le, resolveDynamicComponent as Nn, getCurrentScope as Qa, onScopeDispose as Xa, isRef as Jn, Teleport as Ja } from "vue";
import { format as ct, isBefore as Bt, isEqual as St, isAfter as Et, set as Te, setHours as ba, setMinutes as ka, setSeconds as In, setMilliseconds as Bn, getYear as ve, getMonth as he, setMonth as xa, setYear as rt, addMonths as kt, subMonths as Ft, isValid as Jt, parseISO as er, eachDayOfInterval as wa, getHours as xe, getMinutes as lt, getSeconds as Pt, startOfWeek as Da, endOfWeek as tr, parse as Tn, isDate as nr, addYears as Ma, subYears as $a, addDays as bt, getDay as ar, differenceInCalendarDays as rr, add as Ta, sub as lr, getWeek as or, getISOWeek as sr, isSameQuarter as xn, eachQuarterOfInterval as ir, startOfYear as ur, endOfYear as dr, startOfQuarter as cr, endOfQuarter as ea, getQuarter as ta } from "date-fns";
function Ot() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      fe("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      fe("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      fe("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Ot.compatConfig = {
  MODE: 3
};
function Aa() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      fe("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Aa.compatConfig = {
  MODE: 3
};
function En() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
En.compatConfig = {
  MODE: 3
};
function Fn() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
Fn.compatConfig = {
  MODE: 3
};
function Hn() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      fe("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Hn.compatConfig = {
  MODE: 3
};
function Vn() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Vn.compatConfig = {
  MODE: 3
};
function Ln() {
  return k(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      fe("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ln.compatConfig = {
  MODE: 3
};
function Un(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Sa = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Sa);
var fr = Sa.exports, An = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(An, An.exports);
var vr = An.exports;
const mr = /* @__PURE__ */ Un(vr);
var Sn = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
  }
  e.exports = t.default;
})(Sn, Sn.exports);
var gr = Sn.exports;
const na = /* @__PURE__ */ Un(gr);
function yr(e, t) {
  var r = kr(t);
  return r.formatToParts ? pr(r, e) : br(r, e);
}
var hr = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function pr(e, t) {
  try {
    for (var r = e.formatToParts(t), a = [], n = 0; n < r.length; n++) {
      var o = hr[r[n].type];
      o >= 0 && (a[o] = parseInt(r[n].value, 10));
    }
    return a;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function br(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [a[3], a[1], a[2], a[4], a[5], a[6]];
}
var fn = {};
function kr(e) {
  if (!fn[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    fn[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return fn[e];
}
function zn(e, t, r, a, n, o, i) {
  var c = /* @__PURE__ */ new Date(0);
  return c.setUTCFullYear(e, t, r), c.setUTCHours(a, n, o, i), c;
}
var aa = 36e5, wr = 6e4, vn = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Wn(e, t, r) {
  var a, n;
  if (e === "" || (a = vn.timezoneZ.exec(e), a))
    return 0;
  var o;
  if (a = vn.timezoneHH.exec(e), a)
    return o = parseInt(a[1], 10), ra(o) ? -(o * aa) : NaN;
  if (a = vn.timezoneHHMM.exec(e), a) {
    o = parseInt(a[1], 10);
    var i = parseInt(a[2], 10);
    return ra(o, i) ? (n = Math.abs(o) * aa + i * wr, o > 0 ? -n : n) : NaN;
  }
  if ($r(e)) {
    t = new Date(t || Date.now());
    var c = r ? t : Dr(t), p = Pn(c, e), T = r ? p : Mr(t, p, e);
    return -T;
  }
  return NaN;
}
function Dr(e) {
  return zn(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function Pn(e, t) {
  var r = yr(e, t), a = zn(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), n = e.getTime(), o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, a - n;
}
function Mr(e, t, r) {
  var a = e.getTime(), n = a - t, o = Pn(new Date(n), r);
  if (t === o)
    return t;
  n -= o - t;
  var i = Pn(new Date(n), r);
  return o === i ? o : Math.max(o, i);
}
function ra(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var la = {};
function $r(e) {
  if (la[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), la[e] = !0, !0;
  } catch {
    return !1;
  }
}
var Pa = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, mn = 36e5, oa = 6e4, Tr = 2, Ve = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Pa
};
function Cn(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, a = r.additionalDigits == null ? Tr : mr(r.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = Ar(e), o = Sr(n.date, a), i = o.year, c = o.restDateString, p = Pr(c, i);
  if (isNaN(p))
    return /* @__PURE__ */ new Date(NaN);
  if (p) {
    var T = p.getTime(), D = 0, R;
    if (n.time && (D = Cr(n.time), isNaN(D)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || r.timeZone) {
      if (R = Wn(n.timeZone || r.timeZone, new Date(T + D)), isNaN(R))
        return /* @__PURE__ */ new Date(NaN);
    } else
      R = na(new Date(T + D)), R = na(new Date(T + D + R));
    return new Date(T + D + R);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Ar(e) {
  var t = {}, r = Ve.dateTimePattern.exec(e), a;
  if (r ? (t.date = r[1], a = r[3]) : (r = Ve.datePattern.exec(e), r ? (t.date = r[1], a = r[2]) : (t.date = null, a = e)), a) {
    var n = Ve.timeZone.exec(a);
    n ? (t.time = a.replace(n[1], ""), t.timeZone = n[1].trim()) : t.time = a;
  }
  return t;
}
function Sr(e, t) {
  var r = Ve.YYY[t], a = Ve.YYYYY[t], n;
  if (n = Ve.YYYY.exec(e) || a.exec(e), n) {
    var o = n[1];
    return {
      year: parseInt(o, 10),
      restDateString: e.slice(o.length)
    };
  }
  if (n = Ve.YY.exec(e) || r.exec(e), n) {
    var i = n[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: e.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function Pr(e, t) {
  if (t === null)
    return null;
  var r, a, n, o;
  if (e.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(t), a;
  if (r = Ve.MM.exec(e), r)
    return a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1, ia(t, n) ? (a.setUTCFullYear(t, n), a) : /* @__PURE__ */ new Date(NaN);
  if (r = Ve.DDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0);
    var i = parseInt(r[1], 10);
    return Or(t, i) ? (a.setUTCFullYear(t, 0, i), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Ve.MMDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1;
    var c = parseInt(r[2], 10);
    return ia(t, n, c) ? (a.setUTCFullYear(t, n, c), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Ve.Www.exec(e), r)
    return o = parseInt(r[1], 10) - 1, ua(t, o) ? sa(t, o) : /* @__PURE__ */ new Date(NaN);
  if (r = Ve.WwwD.exec(e), r) {
    o = parseInt(r[1], 10) - 1;
    var p = parseInt(r[2], 10) - 1;
    return ua(t, o, p) ? sa(t, o, p) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Cr(e) {
  var t, r, a;
  if (t = Ve.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), gn(r) ? r % 24 * mn : NaN;
  if (t = Ve.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), a = parseFloat(t[2].replace(",", ".")), gn(r, a) ? r % 24 * mn + a * oa : NaN;
  if (t = Ve.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), a = parseInt(t[2], 10);
    var n = parseFloat(t[3].replace(",", "."));
    return gn(r, a, n) ? r % 24 * mn + a * oa + n * 1e3 : NaN;
  }
  return null;
}
function sa(e, t, r) {
  t = t || 0, r = r || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var n = a.getUTCDay() || 7, o = t * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
var _r = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Rr = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ca(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ia(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var a = Ca(e);
    if (a && r > Rr[t] || !a && r > _r[t])
      return !1;
  }
  return !0;
}
function Or(e, t) {
  if (t < 1)
    return !1;
  var r = Ca(e);
  return !(r && t > 366 || !r && t > 365);
}
function ua(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function gn(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
var _n = { exports: {} }, Rn = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a, n) {
    if (a == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (a[o] = n[o]);
    return a;
  }
  e.exports = t.default;
})(Rn, Rn.exports);
var Yr = Rn.exports;
(function(e, t) {
  var r = fr.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var a = r(Yr);
  function n(o) {
    return (0, a.default)({}, o);
  }
  e.exports = t.default;
})(_n, _n.exports);
var Nr = _n.exports;
const Ir = /* @__PURE__ */ Un(Nr);
function Br(e, t, r) {
  var a = Cn(e, r), n = Wn(t, a, !0), o = new Date(a.getTime() - n), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), i.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), i;
}
function Er(e, t, r) {
  if (typeof e == "string" && !e.match(Pa)) {
    var a = Ir(r);
    return a.timeZone = t, Cn(e, a);
  }
  var n = Cn(e, r), o = zn(
    n.getFullYear(),
    n.getMonth(),
    n.getDate(),
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ).getTime(), i = Wn(t, new Date(o));
  return new Date(o + i);
}
function da(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function Fr(e) {
  return (t) => ct(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "EEEEEE", { locale: e });
}
const Hr = (e, t, r) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let n;
  if (e !== null)
    try {
      n = a.map(Fr(e));
    } catch {
      n = a.map(da(t));
    }
  else
    n = a.map(da(t));
  const o = n.slice(0, r), i = n.slice(r + 1, n.length);
  return [n[r]].concat(...i).concat(...o);
}, jn = (e, t) => {
  const r = [];
  for (let a = +e[0]; a <= +e[1]; a++)
    r.push({ value: +a, text: `${a}` });
  return t ? r.reverse() : r;
}, _a = (e, t, r) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((o) => {
    const i = o < 10 ? `0${o}` : o;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const o = r === "long" ? "MMMM" : "MMM";
      return a.map((i, c) => {
        const p = ct(i, o, { locale: e });
        return {
          text: p.charAt(0).toUpperCase() + p.substring(1),
          value: c
        };
      });
    } catch {
    }
  const n = new Intl.DateTimeFormat(t, { month: r, timeZone: "UTC" });
  return a.map((o, i) => {
    const c = n.format(o);
    return {
      text: c.charAt(0).toUpperCase() + c.substring(1),
      value: i
    };
  });
}, Vr = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Re = (e) => {
  const t = v(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, Lr = (e) => Object.assign({ type: "dot" }, e), Ra = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, tn = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Ce = (e) => e, ca = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, fa = (e) => e === null, Ur = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, zr = (e) => {
  const t = [], r = (a) => a.filter((n) => n);
  for (let a = 0; a < e.length; a += 3) {
    const n = [e[a], e[a + 1], e[a + 2]];
    t.push(r(n));
  }
  return t;
}, Ht = (e, t, r) => {
  const a = r != null, n = t != null;
  if (!a && !n)
    return !1;
  const o = +r, i = +t;
  return a && n ? +e > o || +e < i : a ? +e > o : n ? +e < i : !1;
}, Ct = (e, t) => zr(e).map((r) => r.map((a) => {
  const { active: n, disabled: o, isBetween: i, highlighted: c } = t(a);
  return {
    ...a,
    active: n,
    disabled: o,
    className: {
      dp__overlay_cell_active: n,
      dp__overlay_cell: !n,
      dp__overlay_cell_disabled: o,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: o && n,
      dp__cell_in_between: i,
      "dp--highlighted": c
    }
  };
})), ft = (e, t, r = !1) => {
  e && t.allowStopPropagation && (r && e.stopImmediatePropagation(), e.stopPropagation());
}, Wr = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function jr(e, t) {
  let r = [...document.querySelectorAll(Wr())];
  r = r.filter((n) => !e.contains(n) || n.hasAttribute("data-datepicker-instance"));
  const a = r.indexOf(e);
  if (a >= 0 && (t ? a - 1 >= 0 : a + 1 <= r.length))
    return r[a + (t ? -1 : 1)];
}
const Kr = (e, t) => {
  let r;
  return function(...a) {
    clearTimeout(r), r = setTimeout(() => {
      e(...a);
    }, t);
  };
}, va = (e, t, r, a, n) => {
  const o = Tn(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return Jt(o) && nr(o) ? a || n ? o : Te(o, {
    hours: +r.hours,
    minutes: +(r == null ? void 0 : r.minutes),
    seconds: +(r == null ? void 0 : r.seconds),
    milliseconds: 0
  }) : null;
}, Gr = (e, t, r, a, n) => {
  const o = Array.isArray(r) ? r[0] : r;
  if (typeof t == "string")
    return va(e, t, o, a, n);
  if (Array.isArray(t)) {
    let i = null;
    for (const c of t)
      if (i = va(e, c, o, a, n), i)
        break;
    return i;
  }
  return typeof t == "function" ? t(e) : null;
}, B = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), qr = (e, t, r) => {
  if (t) {
    const n = (e.getMonth() + 1).toString().padStart(2, "0"), o = e.getDate().toString().padStart(2, "0"), i = e.getHours().toString().padStart(2, "0"), c = e.getMinutes().toString().padStart(2, "0"), p = r ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${n}-${o}T${i}:${c}:${p}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Fe = (e) => {
  let t = B(JSON.parse(JSON.stringify(e)));
  return t = ba(t, 0), t = ka(t, 0), t = In(t, 0), t = Bn(t, 0), t;
}, vt = (e, t, r, a) => {
  let n = e ? B(e) : B();
  return (t || t === 0) && (n = ba(n, +t)), (r || r === 0) && (n = ka(n, +r)), (a || a === 0) && (n = In(n, +a)), Bn(n, 0);
}, Ye = (e, t) => !e || !t ? !1 : Bt(Fe(e), Fe(t)), ke = (e, t) => !e || !t ? !1 : St(Fe(e), Fe(t)), Ee = (e, t) => !e || !t ? !1 : Et(Fe(e), Fe(t)), nn = (e, t, r) => e != null && e[0] && (e != null && e[1]) ? Ee(r, e[0]) && Ye(r, e[1]) : e != null && e[0] && t ? Ee(r, e[0]) && Ye(r, t) || Ye(r, e[0]) && Ee(r, t) : !1, Xe = (e) => {
  const t = Te(new Date(e), { date: 1 });
  return Fe(t);
}, yn = (e, t, r) => t && (r || r === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, r] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, wt = (e) => ({
  hours: xe(e),
  minutes: lt(e),
  seconds: Pt(e)
}), Oa = (e, t) => {
  if (t) {
    const r = ve(B(t));
    if (r > e)
      return 12;
    if (r === e)
      return he(B(t));
  }
}, Ya = (e, t) => {
  if (t) {
    const r = ve(B(t));
    return r < e ? -1 : r === e ? he(B(t)) : void 0;
  }
}, _t = (e) => {
  if (e)
    return ve(B(e));
}, et = (e, t) => t ? Br(e, t) : e, Na = (e, t) => t ? Er(e, t) : e, Zr = (e) => e instanceof Date ? e : er(e), Ia = (e, t) => {
  const r = Ee(e, t) ? t : e, a = Ee(t, e) ? t : e;
  return wa({ start: r, end: a });
}, Qr = (e) => {
  const t = kt(e, 1);
  return { month: he(t), year: ve(t) };
}, xt = (e, t, r) => {
  const a = Da(et(e, t), { weekStartsOn: +r }), n = tr(et(e, t), { weekStartsOn: +r });
  return [a, n];
}, Ba = (e, t) => {
  const r = {
    hours: xe(B()),
    minutes: lt(B()),
    seconds: t ? Pt(B()) : 0
  };
  return Object.assign(r, e);
}, dt = (e, t, r) => [Te(B(e), { date: 1 }), Te(B(), { month: t, year: r, date: 1 })], ot = (e, t, r) => {
  let a = e ? B(e) : B();
  return (t || t === 0) && (a = xa(a, t)), r && (a = rt(a, r)), a;
}, Ea = (e, t, r, a, n) => {
  if (!a || n && !t || !n && !r)
    return !1;
  const o = n ? kt(e, 1) : Ft(e, 1), i = [he(o), ve(o)];
  return n ? !Jr(...i, t) : !Xr(...i, r);
}, Xr = (e, t, r) => Ye(...dt(r, e, t)) || ke(...dt(r, e, t)), Jr = (e, t, r) => Ee(...dt(r, e, t)) || ke(...dt(r, e, t)), Fa = (e, t, r, a, n, o, i) => {
  if (typeof t == "function" && !i)
    return t(e);
  const c = r ? { locale: r } : void 0;
  return Array.isArray(e) ? `${ct(e[0], o, c)}${n && !e[1] ? "" : a}${e[1] ? ct(e[1], o, c) : ""}` : ct(e, o, c);
}, Tt = (e) => {
  if (e)
    return null;
  throw new Error(tn.prop("partial-range"));
}, qt = (e, t) => {
  if (t)
    return e();
  throw new Error(tn.prop("range"));
}, On = (e) => Array.isArray(e) ? Jt(e[0]) && (e[1] ? Jt(e[1]) : !0) : e ? Jt(e) : !1, xr = (e, t) => Te(t ?? B(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), hn = (e, t, r, a) => {
  if (!e)
    return !0;
  if (a) {
    const n = r === "max" ? Bt(e, t) : Et(e, t), o = { seconds: 0, milliseconds: 0 };
    return n || St(Te(e, o), Te(t, o));
  }
  return r === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, pn = (e, t, r) => e ? xr(e, t) : B(r ?? t), ma = (e, t, r, a, n) => {
  if (Array.isArray(a)) {
    const i = pn(e, a[0], t), c = pn(e, a[1], t);
    return hn(a[0], i, r, !!t) && hn(a[1], c, r, !!t) && n;
  }
  const o = pn(e, a, t);
  return hn(a, o, r, !!t) && n;
}, bn = (e) => Te(B(), wt(e)), el = (e, t) => Array.isArray(e) ? e.map((r) => B(r)).filter((r) => ve(B(r)) === t).map((r) => he(r)) : [], Ha = (e, t, r) => typeof e == "function" ? e({ month: t, year: r }) : !!e.months.find((a) => a.month === t && a.year === r), Kn = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), Nt = Vt({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Va = () => {
  const e = (a) => {
    Nt.menuFocused = a;
  }, t = (a) => {
    Nt.shiftKeyInMenu !== a && (Nt.shiftKeyInMenu = a);
  };
  return {
    control: z(() => ({ shiftKeyInMenu: Nt.shiftKeyInMenu, menuFocused: Nt.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, $e = Vt({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), kn = ee(null), Zt = ee(!1), wn = ee(!1), Dn = ee(!1), Mn = ee(!1), He = ee(0), Oe = ee(0), yt = () => {
  const e = z(() => Zt.value ? [...$e.selectionGrid, $e.actionRow].filter((g) => g.length) : wn.value ? [
    ...$e.timePicker[0],
    ...$e.timePicker[1],
    Mn.value ? [] : [kn.value],
    $e.actionRow
  ].filter((g) => g.length) : Dn.value ? [...$e.monthPicker, $e.actionRow] : [$e.monthYear, ...$e.calendar, $e.time, $e.actionRow].filter((g) => g.length)), t = (g) => {
    He.value = g ? He.value + 1 : He.value - 1;
    let S = null;
    e.value[Oe.value] && (S = e.value[Oe.value][He.value]), S || (He.value = g ? He.value - 1 : He.value + 1);
  }, r = (g) => {
    if (Oe.value === 0 && !g || Oe.value === e.value.length && g)
      return;
    Oe.value = g ? Oe.value + 1 : Oe.value - 1, e.value[Oe.value] ? e.value[Oe.value] && !e.value[Oe.value][He.value] && He.value !== 0 && (He.value = e.value[Oe.value].length - 1) : Oe.value = g ? Oe.value - 1 : Oe.value + 1;
  }, a = (g) => {
    let S = null;
    e.value[Oe.value] && (S = e.value[Oe.value][He.value]), S ? S.focus({ preventScroll: !Zt.value }) : He.value = g ? He.value - 1 : He.value + 1;
  }, n = () => {
    t(!0), a(!0);
  }, o = () => {
    t(!1), a(!1);
  }, i = () => {
    r(!1), a(!0);
  }, c = () => {
    r(!0), a(!0);
  }, p = (g, S) => {
    $e[S] = g;
  }, T = (g, S) => {
    $e[S] = g;
  }, D = () => {
    He.value = 0, Oe.value = 0;
  };
  return {
    buildMatrix: p,
    buildMultiLevelMatrix: T,
    setTimePickerBackRef: (g) => {
      kn.value = g;
    },
    setSelectionGrid: (g) => {
      Zt.value = g, D(), g || ($e.selectionGrid = []);
    },
    setTimePicker: (g, S = !1) => {
      wn.value = g, Mn.value = S, D(), g || ($e.timePicker[0] = [], $e.timePicker[1] = []);
    },
    setTimePickerElements: (g, S = 0) => {
      $e.timePicker[S] = g;
    },
    arrowRight: n,
    arrowLeft: o,
    arrowUp: i,
    arrowDown: c,
    clearArrowNav: () => {
      $e.monthYear = [], $e.calendar = [], $e.time = [], $e.actionRow = [], $e.selectionGrid = [], $e.timePicker[0] = [], $e.timePicker[1] = [], Zt.value = !1, wn.value = !1, Mn.value = !1, Dn.value = !1, D(), kn.value = null;
    },
    setMonthPicker: (g) => {
      Dn.value = g, D();
    },
    refSets: $e
    // exposed for testing
  };
}, ga = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), tl = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...e ?? {}
}), ya = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, nl = (e) => {
  const t = typeof e == "object" && e, r = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...r, count: ya(!1) };
  const a = t ? e : {}, n = t ? a.count ?? !0 : e, o = ya(n);
  return Object.assign(r, a, { count: o });
}, al = (e, t, r) => e || (typeof r == "string" ? r : t), rl = (e) => typeof e == "boolean" ? e ? ga({}) : !1 : ga(e), ll = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, ol = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), sl = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), il = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, ul = (e) => ({ ...{
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0
}, ...e ?? {} }), dl = (e, t, r) => {
  const a = {
    dates: Array.isArray(e) ? e.map((n) => B(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: t,
    options: { highlightDisabled: r }
  };
  return typeof e == "function" ? e : { ...a, ...e ?? {} };
}, cl = (e) => typeof e == "object" ? {
  type: e.type,
  hideOnOffsetDates: e.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, Pe = (e) => {
  const t = () => {
    const g = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${g}` : `hh:mm${g} aa`;
  }, r = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", a = (g) => Ba(g, e.enableSeconds), n = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, o = z(() => nl(e.multiCalendars)), i = z(() => n()), c = z(() => tl(e.ariaLabels)), p = z(() => ol(e.filters)), T = z(() => rl(e.transitions)), D = z(() => sl(e.actionRow)), R = z(
    () => al(e.previewFormat, e.format, r())
  ), P = z(() => ll(e.textInput)), M = z(() => il(e.inline)), C = z(() => ul(e.config)), A = z(
    () => dl(e.highlight, e.highlightWeekDays, e.highlightDisabledDays)
  ), q = z(() => cl(e.weekNumbers));
  return {
    defaultedTransitions: T,
    defaultedMultiCalendars: o,
    defaultedStartTime: i,
    defaultedAriaLabels: c,
    defaultedFilters: p,
    defaultedActionRow: D,
    defaultedPreviewFormat: R,
    defaultedTextInput: P,
    defaultedInline: M,
    defaultedConfig: C,
    defaultedHighlight: A,
    defaultedWeekNumbers: q,
    getDefaultPattern: r,
    getDefaultStartTime: n
  };
}, fl = (e, t, r) => {
  const a = ee(), { defaultedTextInput: n, getDefaultPattern: o } = Pe(t), i = ee(""), c = en(t, "format");
  mt(a, () => {
    e("internal-model-change", a.value);
  }), mt(c, () => {
    ne();
  });
  const p = (s) => Na(s, t.timezone), T = (s) => et(s, t.timezone), D = (s, J, de = !1) => Fa(
    s,
    t.format,
    t.formatLocale,
    n.value.rangeSeparator,
    t.modelAuto,
    J ?? o(),
    de
  ), R = (s) => s ? t.modelType ? d(s) : {
    hours: xe(s),
    minutes: lt(s),
    seconds: t.enableSeconds ? Pt(s) : 0
  } : null, P = (s) => t.modelType ? d(s) : { month: he(s), year: ve(s) }, M = (s) => Array.isArray(s) ? t.multiDates ? s.map((J) => C(J, rt(B(), J))) : qt(
    () => [
      rt(B(), s[0]),
      s[1] ? rt(B(), s[1]) : Tt(t.partialRange)
    ],
    t.range
  ) : rt(B(), +s), C = (s, J) => (typeof s == "string" || typeof s == "number") && t.modelType ? O(s) : J, A = (s) => Array.isArray(s) ? [
    C(
      s[0],
      vt(null, +s[0].hours, +s[0].minutes, s[0].seconds)
    ),
    C(
      s[1],
      vt(null, +s[1].hours, +s[1].minutes, s[1].seconds)
    )
  ] : C(s, vt(null, s.hours, s.minutes, s.seconds)), q = (s) => Array.isArray(s) ? t.multiDates ? s.map((J) => C(J, ot(null, +J.month, +J.year))) : qt(
    () => [
      C(s[0], ot(null, +s[0].month, +s[0].year)),
      C(
        s[1],
        s[1] ? ot(null, +s[1].month, +s[1].year) : Tt(t.partialRange)
      )
    ],
    t.range
  ) : C(s, ot(null, +s.month, +s.year)), g = (s) => {
    if (Array.isArray(s))
      return s.map((J) => O(J));
    throw new Error(tn.dateArr("multi-dates"));
  }, S = (s) => {
    if (Array.isArray(s))
      return [B(s[0]), B(s[1])];
    throw new Error(tn.dateArr("week-picker"));
  }, F = (s) => t.modelAuto ? Array.isArray(s) ? [O(s[0]), O(s[1])] : t.autoApply ? [O(s)] : [O(s), null] : Array.isArray(s) ? qt(
    () => [
      O(s[0]),
      s[1] ? O(s[1]) : Tt(t.partialRange)
    ],
    t.range
  ) : O(s), b = () => {
    Array.isArray(a.value) && t.range && a.value.length === 1 && a.value.push(Tt(t.partialRange));
  }, _ = () => {
    const s = a.value;
    return [
      d(s[0]),
      s[1] ? d(s[1]) : Tt(t.partialRange)
    ];
  }, X = () => a.value[1] ? _() : d(Ce(a.value[0])), ae = () => (a.value || []).map((s) => d(s)), V = () => (b(), t.modelAuto ? X() : t.multiDates ? ae() : Array.isArray(a.value) ? qt(() => _(), t.range) : d(Ce(a.value))), ie = (s) => !s || Array.isArray(s) && !s.length ? null : t.timePicker ? A(Ce(s)) : t.monthPicker ? q(Ce(s)) : t.yearPicker ? M(Ce(s)) : t.multiDates ? g(Ce(s)) : t.weekPicker ? S(Ce(s)) : F(Ce(s)), E = (s) => {
    const J = ie(s);
    On(Ce(J)) ? (a.value = Ce(J), ne()) : (a.value = null, i.value = "");
  }, f = () => {
    const s = (J) => ct(J, n.value.format);
    return `${s(a.value[0])} ${n.value.rangeSeparator} ${a.value[1] ? s(a.value[1]) : ""}`;
  }, w = () => r.value && a.value ? Array.isArray(a.value) ? f() : ct(a.value, n.value.format) : D(a.value), L = () => a.value ? t.multiDates ? a.value.map((s) => D(s)).join("; ") : n.value.enabled && typeof n.value.format == "string" ? w() : D(a.value) : "", ne = () => {
    !t.format || typeof t.format == "string" || n.value.enabled && typeof n.value.format == "string" ? i.value = L() : i.value = t.format(a.value);
  }, O = (s) => {
    if (t.utc) {
      const J = new Date(s);
      return t.utc === "preserve" ? new Date(J.getTime() + J.getTimezoneOffset() * 6e4) : J;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? T(new Date(s)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? Tn(s, o(), /* @__PURE__ */ new Date()) : T(Tn(s, t.modelType, /* @__PURE__ */ new Date())) : T(new Date(s));
  }, d = (s) => s ? t.utc ? qr(s, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +p(s) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? D(p(s)) : D(p(s), t.modelType, !0) : p(s) : "", Y = (s, J = !1) => {
    if (e("update:model-value", s), t.emitTimezone && J) {
      const de = Array.isArray(s) ? s.map(($) => et(Ce($)), t.emitTimezone) : et(Ce(s), t.emitTimezone);
      e("update:model-timezone-value", de);
    }
  }, Z = (s) => Array.isArray(a.value) ? t.multiDates ? a.value.map((J) => s(J)) : [
    s(a.value[0]),
    a.value[1] ? s(a.value[1]) : Tt(t.partialRange)
  ] : s(Ce(a.value)), y = (s) => Y(Ce(Z(s)));
  return {
    inputValue: i,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? t.range ? t.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: E,
    formatInputValue: ne,
    emitModelValue: () => (ne(), t.monthPicker ? y(P) : t.timePicker ? y(R) : t.yearPicker ? y(ve) : t.weekPicker ? Y(
      a.value.map((s) => d(s)),
      !0
    ) : Y(V(), !0))
  };
}, vl = (e, t) => {
  const { defaultedFilters: r } = Pe(e), { validateMonthYearInRange: a } = $t(e), n = (T, D) => {
    let R = T;
    return r.value.months.includes(he(R)) ? (R = D ? kt(T, 1) : Ft(T, 1), n(R, D)) : R;
  }, o = (T, D) => {
    let R = T;
    return r.value.years.includes(ve(R)) ? (R = D ? Ma(T, 1) : $a(T, 1), o(R, D)) : R;
  }, i = (T, D = !1) => {
    const R = Te(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let P = T ? kt(R, 1) : Ft(R, 1);
    e.disableYearSelect && (P = rt(P, e.year));
    let M = he(P), C = ve(P);
    r.value.months.includes(M) && (P = n(P, T), M = he(P), C = ve(P)), r.value.years.includes(C) && (P = o(P, T), C = ve(P)), a(M, C, T, e.preventMinMaxNavigation) && c(M, C, D);
  }, c = (T, D, R) => {
    t("update-month-year", { month: T, year: D, fromNav: R });
  }, p = z(() => (T) => Ea(
    Te(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }),
    e.maxDate,
    e.minDate,
    e.preventMinMaxNavigation,
    T
  ));
  return { handleMonthYearChange: i, isDisabled: p, updateMonthYear: c };
};
var At = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(At || {}), Qe = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(Qe || {}), pt = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(pt || {}), Dt = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Dt || {}), at = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(at || {});
const ml = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: r,
  pickerWrapperRef: a,
  inline: n,
  emit: o,
  props: i,
  slots: c
}) => {
  const p = ee({}), T = ee(!1), D = ee({
    top: "0",
    left: "0"
  }), R = ee(!1), P = en(i, "teleportCenter");
  mt(P, () => {
    D.value = JSON.parse(JSON.stringify({})), b();
  });
  const M = (d) => {
    if (i.teleport) {
      const Y = d.getBoundingClientRect();
      return {
        left: Y.left + window.scrollX,
        top: Y.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, C = (d, Y) => {
    D.value.left = `${d + Y - p.value.width}px`;
  }, A = (d) => {
    D.value.left = `${d}px`;
  }, q = (d, Y) => {
    i.position === At.left && A(d), i.position === At.right && C(d, Y), i.position === At.center && (D.value.left = `${d + Y / 2 - p.value.width / 2}px`);
  }, g = (d) => {
    const { width: Y, height: Z } = d.getBoundingClientRect(), { top: y, left: l } = i.altPosition ? i.altPosition(d) : M(d);
    return { top: +y, left: +l, width: Y, height: Z };
  }, S = () => {
    D.value.left = "50%", D.value.top = "50%", D.value.transform = "translate(-50%, -50%)", D.value.position = "fixed", delete D.value.opacity;
  }, F = () => {
    const d = Re(r), { top: Y, left: Z, transform: y } = i.altPosition(d);
    D.value = { top: `${Y}px`, left: `${Z}px`, transform: y ?? "" };
  }, b = (d = !0) => {
    var Y;
    if (!n.value.enabled) {
      if (P.value)
        return S();
      if (i.altPosition !== null)
        return F();
      if (d) {
        const Z = i.teleport ? (Y = t.value) == null ? void 0 : Y.$el : e.value;
        Z && (p.value = Z.getBoundingClientRect()), o("recalculate-position");
      }
      return f();
    }
  }, _ = ({ inputEl: d, left: Y, width: Z }) => {
    window.screen.width > 768 && !T.value && q(Y, Z), V(d);
  }, X = (d) => {
    const { top: Y, left: Z, height: y, width: l } = g(d);
    D.value.top = `${y + Y + +i.offset}px`, R.value = !1, T.value || (D.value.left = `${Z + l / 2 - p.value.width / 2}px`), _({ inputEl: d, left: Z, width: l });
  }, ae = (d) => {
    const { top: Y, left: Z, width: y } = g(d);
    D.value.top = `${Y - +i.offset - p.value.height}px`, R.value = !0, _({ inputEl: d, left: Z, width: y });
  }, V = (d) => {
    if (i.autoPosition) {
      const { left: Y, width: Z } = g(d), { left: y, right: l } = p.value;
      if (!T.value) {
        if (Math.abs(y) !== Math.abs(l)) {
          if (y <= 0)
            return T.value = !0, A(Y);
          if (l >= document.documentElement.clientWidth)
            return T.value = !0, C(Y, Z);
        }
        return q(Y, Z);
      }
    }
  }, ie = () => {
    const d = Re(r);
    if (d) {
      const { height: Y } = p.value, { top: Z, height: y } = d.getBoundingClientRect(), h = window.innerHeight - Z - y, s = Z;
      return Y <= h ? pt.bottom : Y > h && Y <= s ? pt.top : h >= s ? pt.bottom : pt.top;
    }
    return pt.bottom;
  }, E = (d) => ie() === pt.bottom ? X(d) : ae(d), f = () => {
    const d = Re(r);
    if (d)
      return i.autoPosition ? E(d) : X(d);
  }, w = function(d) {
    if (d) {
      const Y = d.scrollHeight > d.clientHeight, y = window.getComputedStyle(d).overflowY.indexOf("hidden") !== -1;
      return Y && !y;
    }
    return !0;
  }, L = function(d) {
    return !d || d === document.body || d.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : w(d) ? d : L(d.parentNode);
  }, ne = (d) => {
    if (d)
      switch (i.position) {
        case At.left:
          return { left: 0, transform: "translateX(0)" };
        case At.right:
          return { left: `${d.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${d.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: R,
    menuStyle: D,
    xCorrect: T,
    setMenuPosition: b,
    getScrollableParent: L,
    shadowRender: (d, Y) => {
      var J, de, $;
      const Z = document.createElement("div"), y = (J = Re(r)) == null ? void 0 : J.getBoundingClientRect();
      Z.setAttribute("id", "dp--temp-container");
      const l = (de = a.value) != null && de.clientWidth ? a.value : document.body;
      l.append(Z);
      const h = ne(y), s = qa(
        d,
        {
          ...Y,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...h }
        },
        Object.fromEntries(
          Object.keys(c).filter((u) => ["right-sidebar", "left-sidebar"].includes(u)).map((u) => [u, c[u]])
        )
      );
      Xn(s, Z), p.value = ($ = s.el) == null ? void 0 : $.getBoundingClientRect(), Xn(null, Z), l.removeChild(Z);
    }
  };
}, ut = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] }
], gl = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], yl = {
  all: () => ut,
  monthYear: () => ut.filter((e) => e.use.includes("month-year")),
  input: () => gl,
  timePicker: () => ut.filter((e) => e.use.includes("time")),
  action: () => ut.filter((e) => e.use.includes("action")),
  calendar: () => ut.filter((e) => e.use.includes("calendar")),
  menu: () => ut.filter((e) => e.use.includes("menu")),
  shared: () => ut.filter((e) => e.use.includes("shared")),
  yearMode: () => ut.filter((e) => e.use.includes("year-mode"))
}, qe = (e, t, r) => {
  const a = [];
  return yl[t]().forEach((n) => {
    e[n.name] && a.push(n.name);
  }), r != null && r.length && r.forEach((n) => {
    n.slot && a.push(n.slot);
  }), a;
}, Lt = (e) => {
  const t = z(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), r = z(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: r };
}, Ut = (e, t) => {
  const r = B(et(/* @__PURE__ */ new Date(), e.timezone)), a = ee([{ month: he(r), year: ve(r) }]), n = Vt({
    hours: e.range ? [xe(r), xe(r)] : xe(r),
    minutes: e.range ? [lt(r), lt(r)] : lt(r),
    seconds: e.range ? [0, 0] : 0
  }), o = z({
    get: () => e.internalModelValue,
    set: (p) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", p);
    }
  }), i = z(
    () => (p) => a.value[p] ? a.value[p].month : 0
  ), c = z(
    () => (p) => a.value[p] ? a.value[p].year : 0
  );
  return {
    calendars: a,
    time: n,
    modelValue: o,
    month: i,
    year: c
  };
}, hl = (e, t) => {
  const { defaultedMultiCalendars: r, defaultedHighlight: a } = Pe(t), { isDisabled: n, matchDate: o } = $t(t), i = ee(null), c = ee(B(et(/* @__PURE__ */ new Date(), t.timezone))), p = (l) => {
    !l.current && t.hideOffsetDates || (i.value = l.value);
  }, T = () => {
    i.value = null;
  }, D = (l) => Array.isArray(e.value) && t.range && e.value[0] && i.value ? l ? Ee(i.value, e.value[0]) : Ye(i.value, e.value[0]) : !0, R = (l, h) => {
    const s = () => e.value ? h ? e.value[0] || null : e.value[1] : null, J = e.value && Array.isArray(e.value) ? s() : null;
    return ke(B(l.value), J);
  }, P = (l) => {
    const h = Array.isArray(e.value) ? e.value[0] : null;
    return l ? !Ye(i.value ?? null, h) : !0;
  }, M = (l, h = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !l.current ? !1 : ke(B(l.value), e.value[h ? 0 : 1]) : t.range ? R(l, h) && P(h) || ke(l.value, Array.isArray(e.value) ? e.value[0] : null) && D(h) : !1, C = (l, h, s) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? l ? !1 : s ? Ee(e.value[0], h.value) : Ye(e.value[0], h.value) : !1, A = (l) => !e.value || t.hideOffsetDates && !l.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? ke(l.value, e.value[0] ? e.value[0] : c.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((h) => ke(h, l.value)) : ke(l.value, e.value ? e.value : c.value), q = (l) => {
    if (t.autoRange || t.weekPicker) {
      if (i.value) {
        if (t.hideOffsetDates && !l.current)
          return !1;
        const h = bt(i.value, +t.autoRange), s = xt(B(i.value), t.timezone, t.weekStart);
        return t.weekPicker ? ke(s[1], B(l.value)) : ke(h, B(l.value));
      }
      return !1;
    }
    return !1;
  }, g = (l) => {
    if (t.autoRange || t.weekPicker) {
      if (i.value) {
        const h = bt(i.value, +t.autoRange);
        if (t.hideOffsetDates && !l.current)
          return !1;
        const s = xt(B(i.value), t.timezone, t.weekStart);
        return t.weekPicker ? Ee(l.value, s[0]) && Ye(l.value, s[1]) : Ee(l.value, i.value) && Ye(l.value, h);
      }
      return !1;
    }
    return !1;
  }, S = (l) => {
    if (t.autoRange || t.weekPicker) {
      if (i.value) {
        if (t.hideOffsetDates && !l.current)
          return !1;
        const h = xt(B(i.value), t.timezone, t.weekStart);
        return t.weekPicker ? ke(h[0], l.value) : ke(i.value, l.value);
      }
      return !1;
    }
    return !1;
  }, F = (l) => nn(e.value, i.value, l.value), b = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, _ = () => t.modelAuto ? Ra(t.internalModelValue) : !0, X = (l) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const h = t.range ? !M(l) && !M(l, !1) : !0;
    return !n(l.value) && !A(l) && !(!l.current && t.hideOffsetDates) && h;
  }, ae = (l) => t.range ? t.modelAuto ? b() && A(l) : !1 : A(l), V = (l) => {
    var h;
    return a.value ? typeof a.value == "function" ? a.value(l.value) : o(
      l.value,
      (h = t.arrMapValues) != null && h.highlightedDates ? t.arrMapValues.highlightedDates : a.value.dates
    ) : !1;
  }, ie = (l) => {
    const h = n(l.value);
    return h && (typeof a.value == "function" ? !a.value(l.value, h) : !a.value.options.highlightDisabled);
  }, E = (l) => {
    var h;
    return typeof a.value == "function" ? a.value(l.value) : (h = a.value.weekdays) == null ? void 0 : h.includes(l.value.getDay());
  }, f = (l) => (t.range || t.weekPicker) && (!(r.value.count > 0) || l.current) && _() && !(!l.current && t.hideOffsetDates) && !A(l) ? F(l) : !1, w = (l) => {
    const { isRangeStart: h, isRangeEnd: s } = O(l), J = t.range ? h || s : !1;
    return {
      dp__cell_offset: !l.current,
      dp__pointer: !t.disabled && !(!l.current && t.hideOffsetDates) && !n(l.value),
      dp__cell_disabled: n(l.value),
      dp__cell_highlight: !ie(l) && (V(l) || E(l)) && !ae(l) && !J && !S(l) && !(f(l) && t.weekPicker) && !s,
      dp__cell_highlight_active: !ie(l) && (V(l) || E(l)) && ae(l),
      dp__today: !t.noToday && ke(l.value, c.value) && l.current
    };
  }, L = (l) => ({
    dp__active_date: ae(l),
    dp__date_hover: X(l)
  }), ne = (l) => ({
    ...d(l),
    ...Y(l),
    dp__range_between_week: f(l) && t.weekPicker
  }), O = (l) => {
    const h = r.value.count > 0 ? l.current && M(l) && _() : M(l) && _(), s = r.value.count > 0 ? l.current && M(l, !1) && _() : M(l, !1) && _();
    return { isRangeStart: h, isRangeEnd: s };
  }, d = (l) => {
    const { isRangeStart: h, isRangeEnd: s } = O(l);
    return {
      dp__range_start: h,
      dp__range_end: s,
      dp__range_between: f(l) && !t.weekPicker,
      dp__date_hover_start: C(X(l), l, !0),
      dp__date_hover_end: C(X(l), l, !1)
    };
  }, Y = (l) => ({
    ...d(l),
    dp__cell_auto_range: g(l),
    dp__cell_auto_range_start: S(l),
    dp__cell_auto_range_end: q(l)
  }), Z = (l) => t.range ? t.autoRange ? Y(l) : t.modelAuto ? { ...L(l), ...d(l) } : d(l) : t.weekPicker ? ne(l) : L(l);
  return {
    setHoverDate: p,
    clearHoverDate: T,
    getDayClassData: (l) => t.hideOffsetDates && !l.current ? {} : {
      ...w(l),
      ...Z(l),
      [t.dayClass ? t.dayClass(l.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    }
  };
}, $t = (e) => {
  const { defaultedFilters: t, defaultedHighlight: r } = Pe(e), a = () => {
    if (e.timezone)
      return e.timezone;
    if (e.utc)
      return "UTC";
  }, n = (f) => {
    const w = Fe(o(B(f))).toISOString(), [L] = w.split("T");
    return L;
  }, o = (f) => e.utc === "preserve" ? Na(f, a()) : et(f, a()), i = (f) => {
    var h;
    const w = e.maxDate ? Ee(f, o(B(e.maxDate))) : !1, L = e.minDate ? Ye(f, o(B(e.minDate))) : !1, ne = D(
      o(f),
      (h = e.arrMapValues) != null && h.disabledDates ? e.arrMapValues.disabledDates : e.disabledDates
    ), d = t.value.months.map((s) => +s).includes(he(f)), Y = e.disabledWeekDays.length ? e.disabledWeekDays.some((s) => +s === ar(f)) : !1, Z = P(f), y = ve(f), l = y < +e.yearRange[0] || y > +e.yearRange[1];
    return !(w || L || ne || d || l || Y || Z);
  }, c = (f, w) => Ye(...dt(e.minDate, f, w)) || ke(...dt(e.minDate, f, w)), p = (f, w) => Ee(...dt(e.maxDate, f, w)) || ke(...dt(e.maxDate, f, w)), T = (f, w, L) => {
    let ne = !1;
    return e.maxDate && L && p(f, w) && (ne = !0), e.minDate && !L && c(f, w) && (ne = !0), ne;
  }, D = (f, w) => f ? w instanceof Map ? !!w.get(n(f)) : Array.isArray(w) ? w.some((L) => ke(o(B(L)), f)) : w ? w(B(JSON.parse(JSON.stringify(f)))) : !1 : !0, R = (f, w, L, ne) => {
    let O = !1;
    return ne ? e.minDate && e.maxDate ? O = T(f, w, L) : (e.minDate && c(f, w) || e.maxDate && p(f, w)) && (O = !0) : O = !0, O;
  }, P = (f) => {
    var w, L, ne, O, d;
    return Array.isArray(e.allowedDates) && !((w = e.allowedDates) != null && w.length) ? !0 : (L = e.arrMapValues) != null && L.allowedDates ? !D(f, (ne = e.arrMapValues) == null ? void 0 : ne.allowedDates) : (O = e.allowedDates) != null && O.length ? !((d = e.allowedDates) != null && d.some(
      (Y) => ke(Fe(Y), o(Fe(f)))
    )) : !1;
  }, M = (f) => !i(f), C = (f) => e.noDisabledRange ? !wa({ start: f[0], end: f[1] }).some((L) => M(L)) : !0, A = (f, w, L = 0) => {
    if (Array.isArray(w) && w[L]) {
      const ne = rr(f, w[L]), O = Ia(w[L], f), d = O.length === 1 ? 0 : O.filter((Z) => M(Z)).length, Y = Math.abs(ne) - d;
      if (e.minRange && e.maxRange)
        return Y >= +e.minRange && Y <= +e.maxRange;
      if (e.minRange)
        return Y >= +e.minRange;
      if (e.maxRange)
        return Y <= +e.maxRange;
    }
    return !0;
  }, q = (f) => new Map(f.map((w) => [n(w), !0])), g = (f) => Array.isArray(f) && f.length > 0, S = () => {
    const f = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return g(e.allowedDates) && (f.allowedDates = q(e.allowedDates)), typeof r.value != "function" && g(r.value.dates) && (f.highlightedDates = q(r.value.dates)), g(e.disabledDates) && (f.disabledDates = q(e.disabledDates)), f;
  }, F = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, b = (f) => Array.isArray(f) ? [f[0] ? bn(f[0]) : null, f[1] ? bn(f[1]) : null] : bn(f), _ = (f, w, L) => f.find(
    (ne) => +ne.hours === xe(w) && ne.minutes === "*" ? !0 : +ne.minutes === lt(w) && +ne.hours === xe(w)
  ) && L, X = (f, w, L) => {
    const [ne, O] = f, [d, Y] = w;
    return !_(ne, d, L) && !_(O, Y, L) && L;
  }, ae = (f, w) => {
    const L = Array.isArray(w) ? w : [w];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? X(e.disabledTimes, L, f) : !L.some((ne) => _(e.disabledTimes, ne, f)) : f;
  }, V = (f, w) => {
    const L = Array.isArray(w) ? [wt(w[0]), w[1] ? wt(w[1]) : void 0] : wt(w), ne = !e.disabledTimes(L);
    return f && ne;
  }, ie = (f, w) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? ae(w, f) : V(w, f) : w;
  return {
    isDisabled: M,
    validateDate: i,
    validateMonthYearInRange: R,
    isDateRangeAllowed: C,
    checkMinMaxRange: A,
    matchDate: D,
    mapDatesArrToMap: S,
    isValidTime: (f) => {
      let w = !0;
      if (!f || F())
        return !0;
      const L = !e.minDate && !e.maxDate ? b(f) : f;
      return (e.maxTime || e.maxDate) && (w = ma(
        e.maxTime,
        e.maxDate,
        "max",
        Ce(L),
        w
      )), (e.minTime || e.minDate) && (w = ma(
        e.minTime,
        e.minDate,
        "min",
        Ce(L),
        w
      )), ie(f, w);
    }
  };
}, an = () => {
  const e = z(() => (a, n) => a == null ? void 0 : a.includes(n)), t = z(() => (a, n) => a.count ? a.solo ? !0 : n === 0 : !0), r = z(() => (a, n) => a.count ? a.solo ? !0 : n === a.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: r };
}, pl = (e, t, r) => {
  const a = ee(0), n = Vt({
    [Dt.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Dt.calendar]: !1,
    [Dt.header]: !1
  }), o = z(() => e.monthPicker), i = (R) => {
    var P;
    if ((P = e.flow) != null && P.length) {
      if (!R && o.value)
        return D();
      n[R] = !0, Object.keys(n).filter((M) => !n[M]).length || D();
    }
  }, c = () => {
    var R;
    (R = e.flow) != null && R.length && a.value !== -1 && (a.value += 1, t("flow-step", a.value), D());
  }, p = () => {
    a.value = -1;
  }, T = (R, P, ...M) => {
    e.flow[a.value] === R && r.value && r.value[P](...M);
  }, D = () => {
    T(at.month, "toggleMonthPicker", !0), T(at.year, "toggleYearPicker", !0), T(at.calendar, "toggleTimePicker", !1, !0), T(at.time, "toggleTimePicker", !0, !0);
    const R = e.flow[a.value];
    (R === at.hours || R === at.minutes || R === at.seconds) && T(R, "toggleTimePicker", !0, !0, R);
  };
  return { childMount: i, updateFlowStep: c, resetFlow: p, flowStep: a };
}, rn = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function, Object],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 }
}, tt = {
  ...rn,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  arrMapValues: { type: Object, default: () => ({}) },
  noOverlayFocus: { type: Boolean, default: !1 }
}, bl = {
  key: 1,
  class: "dp__input_wrap"
}, kl = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], wl = {
  key: 2,
  class: "dp__clear_icon"
}, Dl = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...rn
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, {
      defaultedTextInput: o,
      defaultedAriaLabels: i,
      defaultedInline: c,
      defaultedConfig: p,
      getDefaultPattern: T,
      getDefaultStartTime: D
    } = Pe(n), { checkMinMaxRange: R } = $t(n), P = ee(), M = ee(null), C = ee(!1), A = ee(!1), q = z(
      () => ({
        dp__pointer: !n.disabled && !n.readonly && !o.value.enabled,
        dp__disabled: n.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !n.hideInputIcon,
        dp__input_valid: !!n.state,
        dp__input_invalid: n.state === !1,
        dp__input_focus: C.value || n.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        [n.inputClassName]: !!n.inputClassName
      })
    ), g = () => {
      a("set-input-date", null), n.autoApply && (a("set-empty-date"), P.value = null);
    }, S = (d) => {
      const Y = D();
      return Gr(
        d,
        o.value.format ?? T(),
        Y ?? Ba({}, n.enableSeconds),
        n.inputValue,
        A.value
      );
    }, F = (d) => {
      const { rangeSeparator: Y } = o.value, [Z, y] = d.split(`${Y}`);
      if (Z) {
        const l = S(Z.trim()), h = y ? S(y.trim()) : null, s = l && h ? [l, h] : [l];
        R(h, s, 0) && (P.value = l ? s : null);
      }
    }, b = () => {
      A.value = !0;
    }, _ = (d) => {
      if (n.range)
        F(d);
      else if (n.multiDates) {
        const Y = d.split(";");
        P.value = Y.map((Z) => S(Z.trim())).filter((Z) => Z);
      } else
        P.value = S(d);
    }, X = (d) => {
      var Z;
      const Y = typeof d == "string" ? d : (Z = d.target) == null ? void 0 : Z.value;
      Y !== "" ? (o.value.openMenu && !n.isMenuOpen && a("open"), _(Y), a("set-input-date", P.value)) : g(), A.value = !1, a("update:input-value", Y);
    }, ae = (d) => {
      o.value.enabled ? (_(d.target.value), o.value.enterSubmit && On(P.value) && n.inputValue !== "" ? (a("set-input-date", P.value, !0), P.value = null) : o.value.enterSubmit && n.inputValue === "" && (P.value = null, a("clear"))) : E(d);
    }, V = (d) => {
      o.value.enabled && o.value.tabSubmit && _(d.target.value), o.value.tabSubmit && On(P.value) && n.inputValue !== "" ? (a("set-input-date", P.value, !0, !0), P.value = null) : o.value.tabSubmit && n.inputValue === "" && (P.value = null, a("clear", !0));
    }, ie = () => {
      var d;
      C.value = !0, a("focus"), o.value.enabled && o.value.selectOnFocus && ((d = M.value) == null || d.select());
    }, E = (d) => {
      d.preventDefault(), ft(d, p.value, !0), o.value.enabled && o.value.openMenu && !c.value.input && !n.isMenuOpen ? a("open") : o.value.enabled || a("toggle");
    }, f = () => {
      a("real-blur"), C.value = !1, (!n.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), n.autoApply && o.value.enabled && P.value && !n.isMenuOpen && (a("set-input-date", P.value), a("select-date"), P.value = null);
    }, w = (d) => {
      ft(d, p.value, !0), a("clear");
    }, L = (d) => {
      if (!o.value.enabled) {
        if (d.code === "Tab")
          return;
        d.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var d;
        (d = M.value) == null || d.focus({ preventScroll: !0 });
      },
      setParsedDate: (d) => {
        P.value = d;
      }
    }), (d, Y) => {
      var Z;
      return k(), H("div", { onClick: E }, [
        d.$slots.trigger && !d.$slots["dp-input"] && !v(c).enabled ? re(d.$slots, "trigger", { key: 0 }) : j("", !0),
        !d.$slots.trigger && (!v(c).enabled || v(c).input) ? (k(), H("div", bl, [
          d.$slots["dp-input"] && !d.$slots.trigger && !v(c).enabled ? re(d.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: X,
            onEnter: ae,
            onTab: V,
            onClear: w,
            onBlur: f,
            onKeypress: L,
            onPaste: b,
            openMenu: () => d.$emit("open"),
            closeMenu: () => d.$emit("close"),
            toggleMenu: () => d.$emit("toggle")
          }) : j("", !0),
          d.$slots["dp-input"] ? j("", !0) : (k(), H("input", {
            key: 1,
            id: d.uid ? `dp-input-${d.uid}` : void 0,
            ref_key: "inputRef",
            ref: M,
            name: d.name,
            class: we(q.value),
            inputmode: v(o).enabled ? "text" : "none",
            placeholder: d.placeholder,
            disabled: d.disabled,
            readonly: d.readonly,
            required: d.required,
            value: e.inputValue,
            autocomplete: d.autocomplete,
            "aria-label": (Z = v(i)) == null ? void 0 : Z.input,
            "aria-disabled": d.disabled || void 0,
            "aria-invalid": d.state === !1 ? !0 : void 0,
            onInput: X,
            onKeydown: [
              ce(ae, ["enter"]),
              ce(V, ["tab"]),
              L
            ],
            onBlur: f,
            onFocus: ie,
            onKeypress: L,
            onPaste: b
          }, null, 42, kl)),
          fe("div", {
            onClick: Y[2] || (Y[2] = (y) => a("toggle"))
          }, [
            d.$slots["input-icon"] && !d.hideInputIcon ? (k(), H("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Y[0] || (Y[0] = (y) => a("toggle"))
            }, [
              re(d.$slots, "input-icon")
            ])) : j("", !0),
            !d.$slots["input-icon"] && !d.hideInputIcon && !d.$slots["dp-input"] ? (k(), pe(v(Ot), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: Y[1] || (Y[1] = (y) => a("toggle"))
            })) : j("", !0)
          ]),
          d.$slots["clear-icon"] && e.inputValue && d.clearable && !d.disabled && !d.readonly ? (k(), H("span", wl, [
            re(d.$slots, "clear-icon", { clear: w })
          ])) : j("", !0),
          d.clearable && !d.$slots["clear-icon"] && e.inputValue && !d.disabled && !d.readonly ? (k(), pe(v(Aa), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: Y[3] || (Y[3] = De((y) => w(y), ["prevent"]))
          })) : j("", !0)
        ])) : j("", !0)
      ]);
    };
  }
}), Ml = ["title"], $l = { class: "dp__action_buttons" }, Tl = ["disabled"], Al = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...tt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const r = t, a = e, {
      defaultedActionRow: n,
      defaultedPreviewFormat: o,
      defaultedMultiCalendars: i,
      defaultedTextInput: c,
      defaultedInline: p,
      getDefaultPattern: T
    } = Pe(a), { isValidTime: D } = $t(a), { buildMatrix: R } = yt(), P = ee(null), M = ee(null);
    ze(() => {
      a.arrowNavigation && R([Re(P), Re(M)], "actionRow");
    });
    const C = z(() => a.range && !a.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), A = z(() => !q.value || !g.value || !C.value), q = z(() => !a.enableTimePicker || a.ignoreTimeValidation ? !0 : D(a.internalModelValue)), g = z(() => a.monthPicker ? a.range && Array.isArray(a.internalModelValue) ? !a.internalModelValue.filter((f) => !V(f)).length : V(a.internalModelValue) : !0), S = () => {
      const E = o.value;
      return a.timePicker || a.monthPicker, E(Ce(a.internalModelValue));
    }, F = () => {
      const E = a.internalModelValue;
      return i.value.count > 0 ? `${b(E[0])} - ${b(E[1])}` : [b(E[0]), b(E[1])];
    }, b = (E) => Fa(
      E,
      o.value,
      a.formatLocale,
      c.value.rangeSeparator,
      a.modelAuto,
      T()
    ), _ = z(() => !a.internalModelValue || !a.menuMount ? "" : typeof o.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? F() : a.multiDates ? a.internalModelValue.map((E) => `${b(E)}`) : a.modelAuto ? `${b(a.internalModelValue[0])}` : `${b(a.internalModelValue[0])} -` : b(a.internalModelValue) : S()), X = () => a.multiDates ? "; " : " - ", ae = z(
      () => Array.isArray(_.value) ? _.value.join(X()) : _.value
    ), V = (E) => {
      if (!a.monthPicker)
        return !0;
      let f = !0;
      const w = B(Xe(E));
      if (a.minDate && a.maxDate) {
        const L = B(Xe(a.minDate)), ne = B(Xe(a.maxDate));
        return Ee(w, L) && Ye(w, ne) || ke(w, L) || ke(w, ne);
      }
      if (a.minDate) {
        const L = B(Xe(a.minDate));
        f = Ee(w, L) || ke(w, L);
      }
      if (a.maxDate) {
        const L = B(Xe(a.maxDate));
        f = Ye(w, L) || ke(w, L);
      }
      return f;
    }, ie = () => {
      q.value && g.value && C.value ? r("select-date") : r("invalid-select");
    };
    return (E, f) => (k(), H("div", {
      class: "dp__action_row",
      style: Je(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      E.$slots["action-row"] ? re(E.$slots, "action-row", _e(Ne({ key: 0 }, {
        internalModelValue: E.internalModelValue,
        disabled: A.value,
        selectDate: () => E.$emit("select-date"),
        closePicker: () => E.$emit("close-picker")
      }))) : (k(), H(ye, { key: 1 }, [
        v(n).showPreview ? (k(), H("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ae.value
        }, [
          E.$slots["action-preview"] ? re(E.$slots, "action-preview", {
            key: 0,
            value: E.internalModelValue
          }) : j("", !0),
          E.$slots["action-preview"] ? j("", !0) : (k(), H(ye, { key: 1 }, [
            st(Be(ae.value), 1)
          ], 64))
        ], 8, Ml)) : j("", !0),
        fe("div", $l, [
          E.$slots["action-buttons"] ? re(E.$slots, "action-buttons", {
            key: 0,
            value: E.internalModelValue
          }) : j("", !0),
          E.$slots["action-buttons"] ? j("", !0) : (k(), H(ye, { key: 1 }, [
            !v(p).enabled && v(n).showCancel ? (k(), H("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: P,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: f[0] || (f[0] = (w) => E.$emit("close-picker")),
              onKeydown: [
                f[1] || (f[1] = ce((w) => E.$emit("close-picker"), ["enter"])),
                f[2] || (f[2] = ce((w) => E.$emit("close-picker"), ["space"]))
              ]
            }, Be(E.cancelText), 545)) : j("", !0),
            v(n).showNow ? (k(), H("button", {
              key: 1,
              ref_key: "cancelButtonRef",
              ref: P,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: f[3] || (f[3] = (w) => E.$emit("select-now")),
              onKeydown: [
                f[4] || (f[4] = ce((w) => E.$emit("select-now"), ["enter"])),
                f[5] || (f[5] = ce((w) => E.$emit("select-now"), ["space"]))
              ]
            }, Be(E.nowButtonLabel), 545)) : j("", !0),
            v(n).showSelect ? (k(), H("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: M,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: A.value,
              onKeydown: [
                ce(ie, ["enter"]),
                ce(ie, ["space"])
              ],
              onClick: ie
            }, Be(E.selectText), 41, Tl)) : j("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), Sl = ["onKeydown"], Pl = { class: "dp__selection_grid_header" }, Cl = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], _l = ["aria-label"], zt = /* @__PURE__ */ Ie({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: r }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: n, setMonthPicker: o } = yt(), i = r, c = e, { defaultedAriaLabels: p, defaultedTextInput: T, defaultedConfig: D } = Pe(
      c
    ), { hideNavigationButtons: R } = an(), P = ee(!1), M = ee(null), C = ee(null), A = ee([]), q = ee(), g = ee(null), S = ee(0), F = ee(null);
    Za(() => {
      M.value = null;
    }), ze(() => {
      gt().then(() => f()), c.noOverlayFocus || _(), b(!0);
    }), Yn(() => b(!1));
    const b = (y) => {
      var l;
      c.arrowNavigation && ((l = c.headerRefs) != null && l.length ? o(y) : a(y));
    }, _ = () => {
      var l;
      const y = Re(C);
      y && (T.value.enabled || (M.value ? (l = M.value) == null || l.focus({ preventScroll: !0 }) : y.focus({ preventScroll: !0 })), P.value = y.clientHeight < y.scrollHeight);
    }, X = z(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !c.useRelative,
        "dp--overlay-relative": c.useRelative
      })
    ), ae = z(
      () => c.useRelative ? { height: `${c.height}px`, width: "260px" } : void 0
    ), V = z(() => ({
      dp__overlay_col: !0
    })), ie = z(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: P.value,
        dp__button_bottom: c.isLast
      })
    ), E = z(() => {
      var y, l;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((y = c.items) == null ? void 0 : y.length) <= 6,
        dp__container_block: ((l = c.items) == null ? void 0 : l.length) > 6
      };
    });
    mt(
      () => c.items,
      () => f(),
      { deep: !0 }
    );
    const f = () => {
      gt().then(() => {
        const y = Re(M), l = Re(C), h = Re(g), s = Re(F), J = h ? h.getBoundingClientRect().height : 0;
        l && (l.getBoundingClientRect().height ? S.value = l.getBoundingClientRect().height - J : S.value = D.value.modeHeight - J), y && s && (s.scrollTop = y.offsetTop - s.offsetTop - (S.value / 2 - y.getBoundingClientRect().height) - J);
      });
    }, w = (y) => {
      y.disabled || i("selected", y.value);
    }, L = () => {
      i("toggle"), i("reset-flow");
    }, ne = () => {
      c.escClose && L();
    }, O = (y, l, h, s) => {
      y && ((l.active || l.value === c.focusValue) && (M.value = y), c.arrowNavigation && (Array.isArray(A.value[h]) ? A.value[h][s] = y : A.value[h] = [y], d()));
    }, d = () => {
      var l, h;
      const y = (l = c.headerRefs) != null && l.length ? [c.headerRefs].concat(A.value) : A.value.concat([c.skipButtonRef ? [] : [g.value]]);
      n(Ce(y), (h = c.headerRefs) != null && h.length ? "monthPicker" : "selectionGrid");
    }, Y = (y) => {
      c.arrowNavigation || ft(y, D.value, !0);
    }, Z = (y) => {
      q.value = y, i("hover-value", y);
    };
    return t({ focusGrid: _ }), (y, l) => {
      var h;
      return k(), H("div", {
        ref_key: "gridWrapRef",
        ref: C,
        class: we(X.value),
        style: Je(ae.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          ce(De(ne, ["prevent"]), ["esc"]),
          l[0] || (l[0] = ce(De((s) => Y(s), ["prevent"]), ["left"])),
          l[1] || (l[1] = ce(De((s) => Y(s), ["prevent"]), ["up"])),
          l[2] || (l[2] = ce(De((s) => Y(s), ["prevent"]), ["down"])),
          l[3] || (l[3] = ce(De((s) => Y(s), ["prevent"]), ["right"]))
        ]
      }, [
        fe("div", {
          ref_key: "containerRef",
          ref: F,
          class: we(E.value),
          role: "grid",
          style: Je({ height: `${S.value}px` })
        }, [
          fe("div", Pl, [
            re(y.$slots, "header")
          ]),
          y.$slots.overlay ? re(y.$slots, "overlay", { key: 0 }) : (k(!0), H(ye, { key: 1 }, Ae(y.items, (s, J) => (k(), H("div", {
            key: J,
            class: we(["dp__overlay_row", { dp__flex_row: y.items.length >= 3 }]),
            role: "row"
          }, [
            (k(!0), H(ye, null, Ae(s, (de, $) => (k(), H("div", {
              key: de.value,
              ref_for: !0,
              ref: (u) => O(u, de, J, $),
              role: "gridcell",
              class: we(V.value),
              "aria-selected": de.active,
              "aria-disabled": de.disabled || void 0,
              tabindex: "0",
              onClick: (u) => w(de),
              onKeydown: [
                ce(De((u) => w(de), ["prevent"]), ["enter"]),
                ce(De((u) => w(de), ["prevent"]), ["space"])
              ],
              onMouseover: (u) => Z(de.value)
            }, [
              fe("div", {
                class: we(de.className)
              }, [
                y.$slots.item ? re(y.$slots, "item", {
                  key: 0,
                  item: de
                }) : j("", !0),
                y.$slots.item ? j("", !0) : (k(), H(ye, { key: 1 }, [
                  st(Be(de.text), 1)
                ], 64))
              ], 2)
            ], 42, Cl))), 128))
          ], 2))), 128))
        ], 6),
        y.$slots["button-icon"] ? Qt((k(), H("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: g,
          type: "button",
          "aria-label": (h = v(p)) == null ? void 0 : h.toggleOverlay,
          class: we(ie.value),
          tabindex: "0",
          onClick: L,
          onKeydown: [
            ce(L, ["enter"]),
            ce(L, ["tab"])
          ]
        }, [
          re(y.$slots, "button-icon")
        ], 42, _l)), [
          [Xt, !v(R)(y.hideNavigation, y.type)]
        ]) : j("", !0)
      ], 46, Sl);
    };
  }
}), ln = /* @__PURE__ */ Ie({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean }
  },
  setup(e) {
    const t = e, r = z(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), a = z(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (n, o) => (k(), H("div", {
      class: we({
        dp__menu_inner: !n.stretch,
        "dp--menu--inner-stretched": n.stretch,
        dp__flex_display: n.multiCalendars > 0
      })
    }, [
      (k(!0), H(ye, null, Ae(r.value, (i, c) => (k(), H("div", {
        key: i,
        class: we(a.value)
      }, [
        re(n.$slots, "default", {
          instance: i,
          index: c
        })
      ], 2))), 128))
    ], 2));
  }
}), Rl = ["aria-label", "aria-disabled"], It = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const r = t, a = ee(null);
    return ze(() => r("set-ref", a)), (n, o) => (k(), H("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": n.ariaLabel,
      "aria-disabled": n.disabled || void 0,
      onClick: o[0] || (o[0] = (i) => n.$emit("activate")),
      onKeydown: [
        o[1] || (o[1] = ce(De((i) => n.$emit("activate"), ["prevent"]), ["enter"])),
        o[2] || (o[2] = ce(De((i) => n.$emit("activate"), ["prevent"]), ["space"]))
      ]
    }, [
      fe("span", {
        class: we(["dp__inner_nav", { dp__inner_nav_disabled: n.disabled }])
      }, [
        re(n.$slots, "default")
      ], 2)
    ], 40, Rl));
  }
}), Ol = { class: "dp--year-mode-picker" }, Yl = ["aria-label"], La = /* @__PURE__ */ Ie({
  __name: "YearModePicker",
  props: {
    ...tt,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const r = t, a = e, { showRightIcon: n, showLeftIcon: o } = an(), { defaultedConfig: i, defaultedMultiCalendars: c, defaultedAriaLabels: p, defaultedTransitions: T } = Pe(a), { showTransition: D, transitionName: R } = Lt(T), P = (A = !1, q) => {
      r("toggle-year-picker", { flow: A, show: q });
    }, M = (A) => {
      r("year-select", A);
    }, C = (A = !1) => {
      r("handle-year", A);
    };
    return (A, q) => {
      var g, S, F;
      return k(), H("div", Ol, [
        v(o)(v(c), e.instance) ? (k(), pe(It, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (g = v(p)) == null ? void 0 : g.prevYear,
          disabled: e.isDisabled(!1),
          onActivate: q[0] || (q[0] = (b) => C(!1))
        }, {
          default: ge(() => [
            A.$slots["arrow-left"] ? re(A.$slots, "arrow-left", { key: 0 }) : j("", !0),
            A.$slots["arrow-left"] ? j("", !0) : (k(), pe(v(En), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : j("", !0),
        fe("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (S = v(p)) == null ? void 0 : S.openYearsOverlay,
          onClick: q[1] || (q[1] = () => P(!1)),
          onKeydown: q[2] || (q[2] = ce(() => P(!1), ["enter"]))
        }, [
          A.$slots.year ? re(A.$slots, "year", {
            key: 0,
            year: e.year
          }) : j("", !0),
          A.$slots.year ? j("", !0) : (k(), H(ye, { key: 1 }, [
            st(Be(e.year), 1)
          ], 64))
        ], 40, Yl),
        v(n)(v(c), e.instance) ? (k(), pe(It, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (F = v(p)) == null ? void 0 : F.nextYear,
          disabled: e.isDisabled(!0),
          onActivate: q[3] || (q[3] = (b) => C(!0))
        }, {
          default: ge(() => [
            A.$slots["arrow-right"] ? re(A.$slots, "arrow-right", { key: 0 }) : j("", !0),
            A.$slots["arrow-right"] ? j("", !0) : (k(), pe(v(Fn), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : j("", !0),
        Ge(Rt, {
          name: v(R)(e.showYearPicker),
          css: v(D)
        }, {
          default: ge(() => [
            e.showYearPicker ? (k(), pe(zt, {
              key: 0,
              items: e.items,
              "text-input": A.textInput,
              "esc-close": A.escClose,
              config: A.config,
              "is-last": A.autoApply && !v(i).keepActionRow,
              "hide-navigation": A.hideNavigation,
              type: "year",
              onToggle: P,
              onSelected: q[4] || (q[4] = (b) => M(b))
            }, Ue({
              "button-icon": ge(() => [
                A.$slots["calendar-icon"] ? re(A.$slots, "calendar-icon", { key: 0 }) : j("", !0),
                A.$slots["calendar-icon"] ? j("", !0) : (k(), pe(v(Ot), { key: 1 }))
              ]),
              _: 2
            }, [
              A.$slots["year-overlay-value"] ? {
                name: "item",
                fn: ge(({ item: b }) => [
                  re(A.$slots, "year-overlay-value", {
                    text: b.text,
                    value: b.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation"])) : j("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Gn = (e, t, r) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((a) => ke(e, a))) {
      const a = t.value.filter((n) => !ke(n, e));
      t.value = a.length ? a : null;
    } else
      (r && +r > t.value.length || !r) && t.value.push(e);
  else
    t.value = [e];
}, qn = (e, t, r) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? Ye(t, a[0]) ? (a.unshift(t), r("range-start", a[0]), r("range-start", a[1])) : (a[1] = t, r("range-end", t)) : (a = [t], r("range-start", t)), e.value = a, a;
}, on = (e, t, r, a) => {
  e[0] && e[1] && r && t("auto-apply"), e[0] && !e[1] && a && r && t("auto-apply");
}, Ua = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => et(B(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = et(B(e.value), e.timezone));
}, za = ({
  multiCalendars: e,
  highlight: t,
  calendars: r,
  modelValue: a,
  props: n,
  year: o,
  month: i,
  emit: c
}) => {
  const p = z(() => jn(n.yearRange, n.reverseYears)), T = ee([!1]), D = z(() => (b, _) => {
    const X = Te(Xe(/* @__PURE__ */ new Date()), {
      month: i.value(b),
      year: o.value(b)
    });
    return Ea(X, n.maxDate, n.minDate, n.preventMinMaxNavigation, _);
  }), R = () => {
    for (let b = 0; b < e.value.count; b++)
      if (b === 0)
        r.value[b] = r.value[0];
      else {
        const _ = Te(B(), r.value[b - 1]);
        r.value[b] = { month: he(_), year: ve(Ma(_, 1)) };
      }
  }, P = (b) => {
    if (!b)
      return R();
    const _ = Te(B(), r.value[b]);
    return r.value[0].year = ve($a(_, e.value.count - 1)), R();
  }, M = (b) => n.focusStartDate ? b[0] : b[1] ? b[1] : b[0], C = () => {
    if (a.value) {
      const b = Array.isArray(a.value) ? M(a.value) : a.value;
      r.value[0] = { month: he(b), year: ve(b) };
    }
  };
  ze(() => {
    C(), e.value.count && R();
  });
  const A = (b, _) => {
    r.value[_].year = b, e.value.count && !e.value.solo && P(_);
  }, q = z(() => (b) => Ct(p.value, (_) => {
    const X = o.value(b) === _.value, ae = Ht(_.value, _t(n.minDate), _t(n.maxDate)), V = Kn(t.value, _.value);
    return { active: X, disabled: ae, highlighted: V };
  })), g = (b, _) => {
    A(b, _), F(_);
  }, S = (b, _ = !1) => {
    if (!D.value(b, _)) {
      const X = _ ? o.value(b) + 1 : o.value(b) - 1;
      A(X, b);
    }
  }, F = (b, _ = !1, X) => {
    _ || c("reset-flow"), X !== void 0 ? T.value[b] = X : T.value[b] = !T.value[b], T.value || c("overlay-closed");
  };
  return {
    isDisabled: D,
    groupedYears: q,
    showYearPicker: T,
    selectYear: A,
    toggleYearPicker: F,
    handleYearSelect: g,
    handleYear: S
  };
}, Nl = (e, t) => {
  const { defaultedMultiCalendars: r, defaultedAriaLabels: a, defaultedTransitions: n, defaultedConfig: o, defaultedHighlight: i } = Pe(e), { modelValue: c, year: p, month: T, calendars: D } = Ut(e, t), R = z(() => _a(e.formatLocale, e.locale, e.monthNameFormat)), P = ee(null), {
    selectYear: M,
    groupedYears: C,
    showYearPicker: A,
    toggleYearPicker: q,
    handleYearSelect: g,
    handleYear: S,
    isDisabled: F
  } = za({
    modelValue: c,
    multiCalendars: r,
    highlight: i,
    calendars: D,
    year: p,
    month: T,
    props: e,
    emit: t
  });
  ze(() => {
    e.startDate && (c.value && e.focusStartDate || !c.value) && M(ve(B(e.startDate)), 0);
  });
  const b = (y) => y ? { month: he(y), year: ve(y) } : { month: null, year: null }, _ = () => c.value ? Array.isArray(c.value) ? c.value.map((y) => b(y)) : b(c.value) : b(), X = (y, l) => {
    const h = D.value[y], s = _();
    return Array.isArray(s) ? s.some((J) => J.year === (h == null ? void 0 : h.year) && J.month === l) : (h == null ? void 0 : h.year) === s.year && l === s.month;
  }, ae = (y, l, h) => {
    var J, de;
    const s = _();
    return Array.isArray(s) ? p.value(l) === ((J = s[h]) == null ? void 0 : J.year) && y === ((de = s[h]) == null ? void 0 : de.month) : !1;
  }, V = (y, l) => {
    if (e.range) {
      const h = _();
      if (Array.isArray(c.value) && Array.isArray(h)) {
        const s = ae(y, l, 0) || ae(y, l, 1), J = ot(Xe(B()), y, p.value(l));
        return nn(c.value, P.value, J) && !s;
      }
      return !1;
    }
    return !1;
  }, ie = z(() => (y) => Ct(R.value, (l) => {
    const h = X(y, l.value), s = Ht(
      l.value,
      Oa(p.value(y), e.minDate),
      Ya(p.value(y), e.maxDate)
    ) || el(e.disabledDates, p.value(y)).includes(l.value), J = V(l.value, y), de = Ha(i.value, l.value, p.value(y));
    return { active: h, disabled: s, isBetween: J, highlighted: de };
  })), E = (y, l) => ot(Xe(B()), y, p.value(l)), f = (y, l) => {
    const h = c.value ? c.value : Xe(/* @__PURE__ */ new Date());
    c.value = ot(h, y, p.value(l)), t("auto-apply");
  }, w = (y, l) => {
    const h = qn(c, E(y, l), t);
    on(h, t, e.autoApply, e.modelAuto);
  }, L = (y, l) => {
    Gn(E(y, l), c, e.multiDatesLimit), t("auto-apply", !0);
  }, ne = (y, l) => (D.value[l].month = y, d(l, D.value[l].year, y), e.multiDates ? L(y, l) : e.range ? w(y, l) : f(y, l)), O = (y, l) => {
    M(y, l), d(l, y, null);
  }, d = (y, l, h) => {
    let s = h;
    if (!s && s !== 0) {
      const J = _();
      s = Array.isArray(J) ? J[y].month : J.month;
    }
    t("update-month-year", { instance: y, year: l, month: s });
  };
  return {
    groupedMonths: ie,
    groupedYears: C,
    year: p,
    isDisabled: F,
    defaultedMultiCalendars: r,
    defaultedAriaLabels: a,
    defaultedTransitions: n,
    defaultedConfig: o,
    showYearPicker: A,
    modelValue: c,
    presetDate: (y, l) => {
      Ua({ value: y, modelValue: c, range: e.range, timezone: l ? void 0 : e.timezone }), t("auto-apply");
    },
    setHoverDate: (y, l) => {
      P.value = E(y, l);
    },
    selectMonth: ne,
    selectYear: O,
    toggleYearPicker: q,
    handleYearSelect: g,
    handleYear: S,
    getModelMonthYear: _
  };
}, Il = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...tt
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "mount"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = Mt(), o = qe(n, "yearMode"), i = e;
    ze(() => {
      i.shadow || a("mount", null);
    });
    const {
      groupedMonths: c,
      groupedYears: p,
      year: T,
      isDisabled: D,
      defaultedMultiCalendars: R,
      defaultedConfig: P,
      showYearPicker: M,
      modelValue: C,
      presetDate: A,
      setHoverDate: q,
      selectMonth: g,
      selectYear: S,
      toggleYearPicker: F,
      handleYearSelect: b,
      handleYear: _,
      getModelMonthYear: X
    } = Nl(i, a);
    return t({ getSidebarProps: () => ({
      modelValue: C,
      year: T,
      getModelMonthYear: X,
      selectMonth: g,
      selectYear: S,
      handleYear: _
    }), presetDate: A, toggleYearPicker: (V) => F(0, V) }), (V, ie) => (k(), pe(ln, {
      "multi-calendars": v(R).count,
      stretch: ""
    }, {
      default: ge(({ instance: E }) => [
        V.$slots["month-year"] ? re(V.$slots, "month-year", _e(Ne({ key: 0 }, {
          year: v(T),
          months: v(c)(E),
          years: v(p)(E),
          selectMonth: v(g),
          selectYear: v(S),
          instance: E
        }))) : (k(), pe(zt, {
          key: 1,
          items: v(c)(E),
          "arrow-navigation": V.arrowNavigation,
          "is-last": V.autoApply && !v(P).keepActionRow,
          "esc-close": V.escClose,
          height: v(P).modeHeight,
          config: V.config,
          "no-overlay-focus": !!(V.noOverlayFocus || V.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (f) => v(g)(f, E),
          onHoverValue: (f) => v(q)(f, E)
        }, {
          header: ge(() => [
            Ge(La, Ne(V.$props, {
              items: v(p)(E),
              instance: E,
              "show-year-picker": v(M)[E],
              year: v(T)(E),
              "is-disabled": (f) => v(D)(E, f),
              onHandleYear: (f) => v(_)(E, f),
              onYearSelect: (f) => v(b)(f, E),
              onToggleYearPicker: (f) => v(F)(E, f == null ? void 0 : f.flow, f == null ? void 0 : f.show)
            }), Ue({ _: 2 }, [
              Ae(v(o), (f, w) => ({
                name: f,
                fn: ge((L) => [
                  re(V.$slots, f, _e(Le(L)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), Bl = (e, t) => {
  const { modelValue: r } = Ut(e, t), a = ee(null), { defaultedHighlight: n, defaultedFilters: o } = Pe(e), i = ee();
  ze(() => {
    e.startDate && (r.value && e.focusStartDate || !r.value) && (i.value = ve(B(e.startDate)));
  });
  const c = (M) => Array.isArray(r.value) ? r.value.some((C) => ve(C) === M) : r.value ? ve(r.value) === M : !1, p = (M) => e.range && Array.isArray(r.value) ? nn(r.value, a.value, D(M)) : !1, T = z(() => Ct(jn(e.yearRange, e.reverseYears), (M) => {
    const C = c(M.value), A = Ht(M.value, _t(e.minDate), _t(e.maxDate)) || o.value.years.includes(M.value), q = p(M.value) && !C, g = Kn(n.value, M.value);
    return { active: C, disabled: A, isBetween: q, highlighted: g };
  })), D = (M) => rt(Xe(/* @__PURE__ */ new Date()), M);
  return {
    groupedYears: T,
    modelValue: r,
    focusYear: i,
    setHoverValue: (M) => {
      a.value = rt(Xe(/* @__PURE__ */ new Date()), M);
    },
    selectYear: (M) => {
      var C;
      if (e.multiDates)
        return r.value ? Array.isArray(r.value) && (((C = r.value) == null ? void 0 : C.map((q) => ve(q))).includes(M) ? r.value = r.value.filter((q) => ve(q) !== M) : r.value.push(rt(Fe(B()), M))) : r.value = [rt(Fe(B()), M)], t("auto-apply", !0);
      if (e.range) {
        const A = qn(r, D(M), t);
        return on(A, t, e.autoApply, e.modelAuto);
      }
      r.value = D(M), t("auto-apply");
    }
  };
}, El = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...tt
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, { groupedYears: o, modelValue: i, focusYear: c, selectYear: p, setHoverValue: T } = Bl(n, a), { defaultedConfig: D } = Pe(n);
    return t({ getSidebarProps: () => ({
      modelValue: i,
      selectYear: p
    }) }), (P, M) => (k(), H("div", null, [
      P.$slots["month-year"] ? re(P.$slots, "month-year", _e(Ne({ key: 0 }, {
        years: v(o),
        selectYear: v(p)
      }))) : (k(), pe(zt, {
        key: 1,
        items: v(o),
        "is-last": P.autoApply && !v(D).keepActionRow,
        height: v(D).modeHeight,
        config: P.config,
        "no-overlay-focus": !!(P.noOverlayFocus || P.textInput),
        "focus-value": v(c),
        type: "year",
        "use-relative": "",
        onSelected: v(p),
        onHoverValue: v(T)
      }, Ue({ _: 2 }, [
        P.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ge(({ item: C }) => [
            re(P.$slots, "year-overlay-value", {
              text: C.text,
              value: C.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), Fl = {
  key: 0,
  class: "dp__time_input"
}, Hl = ["aria-label", "onKeydown", "onClick"], Vl = /* @__PURE__ */ fe("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), Ll = /* @__PURE__ */ fe("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), Ul = ["aria-label", "disabled", "onKeydown", "onClick"], zl = ["aria-label", "onKeydown", "onClick"], Wl = /* @__PURE__ */ fe("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), jl = /* @__PURE__ */ fe("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), Kl = { key: 0 }, Gl = ["aria-label", "onKeydown"], ql = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...tt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, { setTimePickerElements: o, setTimePickerBackRef: i } = yt(), { defaultedAriaLabels: c, defaultedTransitions: p, defaultedFilters: T, defaultedConfig: D } = Pe(n), { transitionName: R, showTransition: P } = Lt(p), M = Vt({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), C = ee("AM"), A = ee(null), q = ee([]);
    ze(() => {
      a("mounted");
    });
    const g = (u) => Te(/* @__PURE__ */ new Date(), {
      hours: u.hours,
      minutes: u.minutes,
      seconds: n.enableSeconds ? u.seconds : 0,
      milliseconds: 0
    }), S = z(
      () => (u) => ne(u, n[u]) || b(u, n[u])
    ), F = z(() => ({ hours: n.hours, minutes: n.minutes, seconds: n.seconds })), b = (u, I) => n.range && !n.disableTimeRangeValidation ? !n.validateTime(u, I) : !1, _ = (u, I) => {
      if (n.range && !n.disableTimeRangeValidation) {
        const Q = I ? +n[`${u}Increment`] : -+n[`${u}Increment`], K = n[u] + Q;
        return !n.validateTime(u, K);
      }
      return !1;
    }, X = z(() => (u) => !d(+n[u] + +n[`${u}Increment`], u) || _(u, !0)), ae = z(() => (u) => !d(+n[u] - +n[`${u}Increment`], u) || _(u, !1)), V = (u, I) => Ta(Te(B(), u), I), ie = (u, I) => lr(Te(B(), u), I), E = z(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !n.timePickerInline,
        dp__time_col_reg_block: !n.enableSeconds && n.is24 && !n.timePickerInline,
        dp__time_col_reg_inline: !n.enableSeconds && n.is24 && n.timePickerInline,
        dp__time_col_reg_with_button: !n.enableSeconds && !n.is24,
        dp__time_col_sec: n.enableSeconds && n.is24,
        dp__time_col_sec_with_button: n.enableSeconds && !n.is24
      })
    ), f = z(() => {
      const u = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return n.enableSeconds ? u.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : u;
    }), w = z(() => f.value.filter((u) => !u.separator)), L = z(() => (u) => {
      if (u === "hours") {
        const I = h(+n.hours);
        return { text: I < 10 ? `0${I}` : `${I}`, value: I };
      }
      return { text: n[u] < 10 ? `0${n[u]}` : `${n[u]}`, value: n[u] };
    }), ne = (u, I) => {
      var K;
      if (!n.disabledTimesConfig)
        return !1;
      const Q = n.disabledTimesConfig(n.order, u === "hours" ? I : void 0);
      return Q[u] ? !!((K = Q[u]) != null && K.includes(I)) : !0;
    }, O = (u) => {
      const I = n.is24 ? 24 : 12, Q = u === "hours" ? I : 60, K = +n[`${u}GridIncrement`], te = u === "hours" && !n.is24 ? K : 0, le = [];
      for (let be = te; be < Q; be += K)
        le.push({ value: be, text: be < 10 ? `0${be}` : `${be}` });
      return u === "hours" && !n.is24 && le.push({ value: 0, text: "12" }), Ct(le, (be) => ({ active: !1, disabled: T.value.times[u].includes(be.value) || !d(be.value, u) || ne(u, be.value) || b(u, be.value) }));
    }, d = (u, I) => {
      const Q = n.minTime ? g(yn(n.minTime)) : null, K = n.maxTime ? g(yn(n.maxTime)) : null, te = g(yn(F.value, I, u));
      return Q && K ? (Bt(te, K) || St(te, K)) && (Et(te, Q) || St(te, Q)) : Q ? Et(te, Q) || St(te, Q) : K ? Bt(te, K) || St(te, K) : !0;
    }, Y = (u) => n[`no${u[0].toUpperCase() + u.slice(1)}Overlay`], Z = (u) => {
      Y(u) || (M[u] = !M[u], M[u] || a("overlay-closed"));
    }, y = (u) => u === "hours" ? xe : u === "minutes" ? lt : Pt, l = (u, I = !0) => {
      const Q = I ? V : ie, K = I ? +n[`${u}Increment`] : -+n[`${u}Increment`];
      d(+n[u] + K, u) && a(
        `update:${u}`,
        y(u)(Q({ [u]: +n[u] }, { [u]: +n[`${u}Increment`] }))
      );
    }, h = (u) => n.is24 ? u : (u >= 12 ? C.value = "PM" : C.value = "AM", Vr(u)), s = () => {
      C.value === "PM" ? (C.value = "AM", a("update:hours", n.hours - 12)) : (C.value = "PM", a("update:hours", n.hours + 12)), a("am-pm-change", C.value);
    }, J = (u) => {
      M[u] = !0;
    }, de = (u, I, Q) => {
      if (u && n.arrowNavigation) {
        Array.isArray(q.value[I]) ? q.value[I][Q] = u : q.value[I] = [u];
        const K = q.value.reduce(
          (te, le) => le.map((be, N) => [...te[N] || [], le[N]]),
          []
        );
        i(n.closeTimePickerBtn), A.value && (K[1] = K[1].concat(A.value)), o(K, n.order);
      }
    }, $ = (u, I) => (Z(u), u === "hours" && !n.is24 ? a(`update:${u}`, C.value === "PM" ? I + 12 : I) : a(`update:${u}`, I));
    return t({ openChildCmp: J }), (u, I) => {
      var Q;
      return u.disabled ? j("", !0) : (k(), H("div", Fl, [
        (k(!0), H(ye, null, Ae(f.value, (K, te) => {
          var le, be, N;
          return k(), H("div", {
            key: te,
            class: we(E.value)
          }, [
            K.separator ? (k(), H(ye, { key: 0 }, [
              st(" : ")
            ], 64)) : (k(), H(ye, { key: 1 }, [
              fe("button", {
                ref_for: !0,
                ref: (U) => de(U, te, 0),
                type: "button",
                class: we({
                  dp__btn: !0,
                  dp__inc_dec_button: !u.timePickerInline,
                  dp__inc_dec_button_inline: u.timePickerInline,
                  dp__tp_inline_btn_top: u.timePickerInline,
                  dp__inc_dec_button_disabled: X.value(K.type)
                }),
                "aria-label": (le = v(c)) == null ? void 0 : le.incrementValue(K.type),
                tabindex: "0",
                onKeydown: [
                  ce(De((U) => l(K.type), ["prevent"]), ["enter"]),
                  ce(De((U) => l(K.type), ["prevent"]), ["space"])
                ],
                onClick: (U) => l(K.type)
              }, [
                n.timePickerInline ? (k(), H(ye, { key: 1 }, [
                  Vl,
                  Ll
                ], 64)) : (k(), H(ye, { key: 0 }, [
                  u.$slots["arrow-up"] ? re(u.$slots, "arrow-up", { key: 0 }) : j("", !0),
                  u.$slots["arrow-up"] ? j("", !0) : (k(), pe(v(Vn), { key: 1 }))
                ], 64))
              ], 42, Hl),
              fe("button", {
                ref_for: !0,
                ref: (U) => de(U, te, 1),
                type: "button",
                "aria-label": (be = v(c)) == null ? void 0 : be.openTpOverlay(K.type),
                class: we({
                  dp__time_display: !0,
                  dp__time_display_block: !u.timePickerInline,
                  dp__time_display_inline: u.timePickerInline,
                  "dp--time-invalid": S.value(K.type),
                  "dp--time-overlay-btn": !S.value(K.type)
                }),
                disabled: Y(K.type),
                tabindex: "0",
                onKeydown: [
                  ce(De((U) => Z(K.type), ["prevent"]), ["enter"]),
                  ce(De((U) => Z(K.type), ["prevent"]), ["space"])
                ],
                onClick: (U) => Z(K.type)
              }, [
                u.$slots[K.type] ? re(u.$slots, K.type, {
                  key: 0,
                  text: L.value(K.type).text,
                  value: L.value(K.type).value
                }) : j("", !0),
                u.$slots[K.type] ? j("", !0) : (k(), H(ye, { key: 1 }, [
                  st(Be(L.value(K.type).text), 1)
                ], 64))
              ], 42, Ul),
              fe("button", {
                ref_for: !0,
                ref: (U) => de(U, te, 2),
                type: "button",
                class: we({
                  dp__btn: !0,
                  dp__inc_dec_button: !u.timePickerInline,
                  dp__inc_dec_button_inline: u.timePickerInline,
                  dp__tp_inline_btn_bottom: u.timePickerInline,
                  dp__inc_dec_button_disabled: ae.value(K.type)
                }),
                "aria-label": (N = v(c)) == null ? void 0 : N.decrementValue(K.type),
                tabindex: "0",
                onKeydown: [
                  ce(De((U) => l(K.type, !1), ["prevent"]), ["enter"]),
                  ce(De((U) => l(K.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (U) => l(K.type, !1)
              }, [
                n.timePickerInline ? (k(), H(ye, { key: 1 }, [
                  Wl,
                  jl
                ], 64)) : (k(), H(ye, { key: 0 }, [
                  u.$slots["arrow-down"] ? re(u.$slots, "arrow-down", { key: 0 }) : j("", !0),
                  u.$slots["arrow-down"] ? j("", !0) : (k(), pe(v(Ln), { key: 1 }))
                ], 64))
              ], 42, zl)
            ], 64))
          ], 2);
        }), 128)),
        u.is24 ? j("", !0) : (k(), H("div", Kl, [
          u.$slots["am-pm-button"] ? re(u.$slots, "am-pm-button", {
            key: 0,
            toggle: s,
            value: C.value
          }) : j("", !0),
          u.$slots["am-pm-button"] ? j("", !0) : (k(), H("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: A,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (Q = v(c)) == null ? void 0 : Q.amPmButton,
            tabindex: "0",
            onClick: s,
            onKeydown: [
              ce(De(s, ["prevent"]), ["enter"]),
              ce(De(s, ["prevent"]), ["space"])
            ]
          }, Be(C.value), 41, Gl))
        ])),
        (k(!0), H(ye, null, Ae(w.value, (K, te) => (k(), pe(Rt, {
          key: te,
          name: v(R)(M[K.type]),
          css: v(P)
        }, {
          default: ge(() => [
            M[K.type] ? (k(), pe(zt, {
              key: 0,
              items: O(K.type),
              "is-last": u.autoApply && !v(D).keepActionRow,
              "esc-close": u.escClose,
              type: K.type,
              "text-input": u.textInput,
              config: u.config,
              "arrow-navigation": u.arrowNavigation,
              onSelected: (le) => $(K.type, le),
              onToggle: (le) => Z(K.type),
              onResetFlow: I[0] || (I[0] = (le) => u.$emit("reset-flow"))
            }, Ue({
              "button-icon": ge(() => [
                u.$slots["clock-icon"] ? re(u.$slots, "clock-icon", { key: 0 }) : j("", !0),
                u.$slots["clock-icon"] ? j("", !0) : (k(), pe(Nn(u.timePickerInline ? v(Ot) : v(Hn)), { key: 1 }))
              ]),
              _: 2
            }, [
              u.$slots[`${K.type}-overlay-value`] ? {
                name: "item",
                fn: ge(({ item: le }) => [
                  re(u.$slots, `${K.type}-overlay-value`, {
                    text: le.text,
                    value: le.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "onSelected", "onToggle"])) : j("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), Zl = { class: "dp--tp-wrap" }, Ql = ["aria-label", "tabindex"], Xl = ["tabindex"], Jl = ["aria-label"], Wa = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...tt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, { buildMatrix: o, setTimePicker: i } = yt(), c = Mt(), { defaultedTransitions: p, defaultedAriaLabels: T, defaultedTextInput: D, defaultedConfig: R } = Pe(n), { transitionName: P, showTransition: M } = Lt(p), { hideNavigationButtons: C } = an(), A = ee(null), q = ee(null), g = ee([]), S = ee(null);
    ze(() => {
      a("mount"), !n.timePicker && n.arrowNavigation ? o([Re(A.value)], "time") : i(!0, n.timePicker);
    });
    const F = z(() => n.range && n.modelAuto ? Ra(n.internalModelValue) : !0), b = ee(!1), _ = (O) => ({
      hours: Array.isArray(n.hours) ? n.hours[O] : n.hours,
      minutes: Array.isArray(n.minutes) ? n.minutes[O] : n.minutes,
      seconds: Array.isArray(n.seconds) ? n.seconds[O] : n.seconds
    }), X = z(() => {
      const O = [];
      if (n.range)
        for (let d = 0; d < 2; d++)
          O.push(_(d));
      else
        O.push(_(0));
      return O;
    }), ae = (O, d = !1, Y = "") => {
      d || a("reset-flow"), b.value = O, a(O ? "overlay-opened" : "overlay-closed"), n.arrowNavigation && i(O), gt(() => {
        Y !== "" && g.value[0] && g.value[0].openChildCmp(Y);
      });
    }, V = z(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: n.autoApply && !R.value.keepActionRow
    })), ie = qe(c, "timePicker"), E = (O, d, Y) => n.range ? d === 0 ? [O, X.value[1][Y]] : [X.value[0][Y], O] : O, f = (O) => {
      a("update:hours", O);
    }, w = (O) => {
      a("update:minutes", O);
    }, L = (O) => {
      a("update:seconds", O);
    }, ne = () => {
      if (S.value && !D.value.enabled && !n.noOverlayFocus) {
        const O = Ur(S.value);
        O && O.focus({ preventScroll: !0 });
      }
    };
    return t({ toggleTimePicker: ae }), (O, d) => {
      var Y;
      return k(), H("div", Zl, [
        !O.timePicker && !O.timePickerInline ? Qt((k(), H("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: A,
          type: "button",
          class: we(V.value),
          "aria-label": (Y = v(T)) == null ? void 0 : Y.openTimePicker,
          tabindex: O.noOverlayFocus ? void 0 : 0,
          onKeydown: [
            d[0] || (d[0] = ce((Z) => ae(!0), ["enter"])),
            d[1] || (d[1] = ce((Z) => ae(!0), ["space"]))
          ],
          onClick: d[2] || (d[2] = (Z) => ae(!0))
        }, [
          O.$slots["clock-icon"] ? re(O.$slots, "clock-icon", { key: 0 }) : j("", !0),
          O.$slots["clock-icon"] ? j("", !0) : (k(), pe(v(Hn), { key: 1 }))
        ], 42, Ql)), [
          [Xt, !v(C)(O.hideNavigation, "time")]
        ]) : j("", !0),
        Ge(Rt, {
          name: v(P)(b.value),
          css: v(M) && !O.timePickerInline
        }, {
          default: ge(() => {
            var Z;
            return [
              b.value || O.timePicker || O.timePickerInline ? (k(), H("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: S,
                class: we({
                  dp__overlay: !O.timePickerInline,
                  "dp--overlay-absolute": !n.timePicker && !O.timePickerInline,
                  "dp--overlay-relative": n.timePicker
                }),
                style: Je(O.timePicker ? { height: `${v(R).modeHeight}px` } : void 0),
                tabindex: O.timePickerInline ? void 0 : 0
              }, [
                fe("div", {
                  class: we(
                    O.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  O.$slots["time-picker-overlay"] ? re(O.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: f,
                    setMinutes: w,
                    setSeconds: L
                  }) : j("", !0),
                  O.$slots["time-picker-overlay"] ? j("", !0) : (k(), H("div", {
                    key: 1,
                    class: we(O.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (k(!0), H(ye, null, Ae(X.value, (y, l) => Qt((k(), pe(ql, Ne({ key: l }, {
                      ...O.$props,
                      order: l,
                      hours: y.hours,
                      minutes: y.minutes,
                      seconds: y.seconds,
                      closeTimePickerBtn: q.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: l === 0 ? O.fixedStart : O.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: g,
                      "validate-time": (h, s) => e.validateTime(h, E(s, l, h)),
                      "onUpdate:hours": (h) => f(E(h, l, "hours")),
                      "onUpdate:minutes": (h) => w(E(h, l, "minutes")),
                      "onUpdate:seconds": (h) => L(E(h, l, "seconds")),
                      onMounted: ne,
                      onOverlayClosed: ne,
                      onAmPmChange: d[3] || (d[3] = (h) => O.$emit("am-pm-change", h))
                    }), Ue({ _: 2 }, [
                      Ae(v(ie), (h, s) => ({
                        name: h,
                        fn: ge((J) => [
                          re(O.$slots, h, _e(Le(J)))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Xt, l === 0 ? !0 : F.value]
                    ])), 128))
                  ], 2)),
                  !O.timePicker && !O.timePickerInline ? Qt((k(), H("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: q,
                    type: "button",
                    class: we(V.value),
                    "aria-label": (Z = v(T)) == null ? void 0 : Z.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      d[4] || (d[4] = ce((y) => ae(!1), ["enter"])),
                      d[5] || (d[5] = ce((y) => ae(!1), ["space"]))
                    ],
                    onClick: d[6] || (d[6] = (y) => ae(!1))
                  }, [
                    O.$slots["calendar-icon"] ? re(O.$slots, "calendar-icon", { key: 0 }) : j("", !0),
                    O.$slots["calendar-icon"] ? j("", !0) : (k(), pe(v(Ot), { key: 1 }))
                  ], 42, Jl)), [
                    [Xt, !v(C)(O.hideNavigation, "time")]
                  ]) : j("", !0)
                ], 2)
              ], 14, Xl)) : j("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), ja = (e, t, r, a) => {
  const n = (g, S) => Array.isArray(t[g]) ? t[g][S] : t[g], o = (g) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[g] : t.seconds : 0, i = (g, S) => g ? S !== void 0 ? vt(g, n("hours", S), n("minutes", S), o(S)) : vt(g, t.hours, t.minutes, o()) : In(B(), o(S)), c = (g, S) => {
    t[g] = S;
  }, p = (g, S) => {
    const F = Object.fromEntries(
      Object.keys(t).map((b) => b === g ? [b, S] : [b, t[b]].slice())
    );
    if (e.range && !e.disableTimeRangeValidation) {
      const b = (X) => r.value ? vt(
        r.value[X],
        F.hours[X],
        F.minutes[X],
        F.seconds[X]
      ) : null, _ = (X) => Bn(r.value[X], 0);
      return !(ke(b(0), b(1)) && (Et(b(0), _(1)) || Bt(b(1), _(0))));
    }
    return !0;
  }, T = (g, S) => {
    p(g, S) && (c(g, S), a && a());
  }, D = (g) => {
    T("hours", g);
  }, R = (g) => {
    T("minutes", g);
  }, P = (g) => {
    T("seconds", g);
  }, M = (g, S, F, b) => {
    S && D(g), !S && !F && R(g), F && P(g), r.value && b(r.value);
  }, C = (g) => {
    if (g) {
      const S = Array.isArray(g), F = S ? [+g[0].hours, +g[1].hours] : +g.hours, b = S ? [+g[0].minutes, +g[1].minutes] : +g.minutes, _ = S ? [+g[0].seconds, +g[1].seconds] : +g.seconds;
      c("hours", F), c("minutes", b), e.enableSeconds && c("seconds", _);
    }
  }, A = (g, S) => {
    const F = {
      hours: Array.isArray(t.hours) ? t.hours[g] : t.hours,
      disabledArr: []
    };
    return (S || S === 0) && (F.hours = S), Array.isArray(e.disabledTimes) && (F.disabledArr = e.range && Array.isArray(e.disabledTimes[g]) ? e.disabledTimes[g] : e.disabledTimes), F;
  }, q = z(() => (g, S) => {
    var F;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: b, hours: _ } = A(g, S), X = b.filter((ae) => +ae.hours === _);
      return ((F = X[0]) == null ? void 0 : F.minutes) === "*" ? { hours: [_], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (X == null ? void 0 : X.map((ae) => +ae.minutes)) ?? [],
        seconds: (X == null ? void 0 : X.map((ae) => ae.seconds ? +ae.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: c,
    updateHours: D,
    updateMinutes: R,
    updateSeconds: P,
    getSetDateTime: i,
    updateTimeValues: M,
    getSecondsValue: o,
    assignStartTime: C,
    validateTime: p,
    disabledTimesConfig: q
  };
}, xl = (e, t) => {
  const { modelValue: r, time: a } = Ut(e, t), { defaultedStartTime: n } = Pe(e), { updateTimeValues: o, getSetDateTime: i, setTime: c, assignStartTime: p, disabledTimesConfig: T, validateTime: D } = ja(e, a, r), R = (F) => {
    const { hours: b, minutes: _, seconds: X } = F;
    return { hours: +b, minutes: +_, seconds: X ? +X : 0 };
  }, P = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const b = R(e.startTime[0]), _ = R(e.startTime[1]);
        return [Te(B(), b), Te(B(), _)];
      }
      const F = R(e.startTime);
      return Te(B(), F);
    }
    return e.range ? [null, null] : null;
  }, M = () => {
    if (e.range) {
      const [F, b] = P();
      r.value = [i(F, 0), i(b, 1)];
    } else
      r.value = i(P());
  }, C = (F) => Array.isArray(F) ? [wt(B(F[0])), wt(B(F[1]))] : [wt(F ?? B())], A = (F, b, _) => {
    c("hours", F), c("minutes", b), c("seconds", e.enableSeconds ? _ : 0);
  }, q = () => {
    const [F, b] = C(r.value);
    return e.range ? A(
      [F.hours, b.hours],
      [F.minutes, b.minutes],
      [F.seconds, b.minutes]
    ) : A(F.hours, F.minutes, F.seconds);
  };
  ze(() => {
    if (!e.shadow)
      return p(n.value), r.value ? q() : M();
  });
  const g = () => {
    Array.isArray(r.value) ? r.value = r.value.map((F, b) => F && i(F, b)) : r.value = i(r.value), t("time-update");
  };
  return {
    modelValue: r,
    time: a,
    disabledTimesConfig: T,
    updateTime: (F, b = !0, _ = !1) => {
      o(F, b, _, g);
    },
    validateTime: D
  };
}, eo = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...tt
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, o = Mt(), i = qe(o, "timePicker"), { time: c, modelValue: p, disabledTimesConfig: T, updateTime: D, validateTime: R } = xl(n, a);
    return t({ getSidebarProps: () => ({
      modelValue: p,
      time: c,
      updateTime: D
    }) }), (M, C) => (k(), pe(ln, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ge(() => [
        Ge(Wa, Ne(M.$props, {
          hours: v(c).hours,
          minutes: v(c).minutes,
          seconds: v(c).seconds,
          "internal-model-value": M.internalModelValue,
          "disabled-times-config": v(T),
          "validate-time": v(R),
          "onUpdate:hours": C[0] || (C[0] = (A) => v(D)(A)),
          "onUpdate:minutes": C[1] || (C[1] = (A) => v(D)(A, !1)),
          "onUpdate:seconds": C[2] || (C[2] = (A) => v(D)(A, !1, !0)),
          onAmPmChange: C[3] || (C[3] = (A) => M.$emit("am-pm-change", A))
        }), Ue({ _: 2 }, [
          Ae(v(i), (A, q) => ({
            name: A,
            fn: ge((g) => [
              re(M.$slots, A, _e(Le(g)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), to = { class: "dp__month_year_row" }, no = ["aria-label", "onClick", "onKeydown"], ao = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...tt
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, {
      defaultedTransitions: o,
      defaultedAriaLabels: i,
      defaultedMultiCalendars: c,
      defaultedFilters: p,
      defaultedConfig: T,
      defaultedHighlight: D
    } = Pe(n), { transitionName: R, showTransition: P } = Lt(o), { buildMatrix: M } = yt(), { handleMonthYearChange: C, isDisabled: A, updateMonthYear: q } = vl(n, a), { showLeftIcon: g, showRightIcon: S } = an(), F = ee(!1), b = ee(!1), _ = ee([null, null, null, null]);
    ze(() => {
      a("mount");
    });
    const X = (l) => ({
      get: () => n[l],
      set: (h) => {
        const s = l === Qe.month ? Qe.year : Qe.month;
        a("update-month-year", { [l]: h, [s]: n[s] }), l === Qe.month ? ne(!0) : O(!0);
      }
    }), ae = z(X(Qe.month)), V = z(X(Qe.year)), ie = z(() => (l) => ({
      month: n.month,
      year: n.year,
      items: l === Qe.month ? n.months : n.years,
      instance: n.instance,
      updateMonthYear: q,
      toggle: l === Qe.month ? ne : O
    })), E = z(() => {
      const l = n.months.find((h) => h.value === n.month);
      return l || { text: "", value: 0 };
    }), f = z(() => Ct(n.months, (l) => {
      const h = n.month === l.value, s = Ht(
        l.value,
        Oa(n.year, n.minDate),
        Ya(n.year, n.maxDate)
      ) || p.value.months.includes(l.value), J = Ha(D.value, l.value, n.year);
      return { active: h, disabled: s, highlighted: J };
    })), w = z(() => Ct(n.years, (l) => {
      const h = n.year === l.value, s = Ht(l.value, _t(n.minDate), _t(n.maxDate)) || p.value.years.includes(l.value), J = Kn(D.value, l.value);
      return { active: h, disabled: s, highlighted: J };
    })), L = (l, h) => {
      h !== void 0 ? l.value = h : l.value = !l.value, l.value || a("overlay-closed");
    }, ne = (l = !1, h) => {
      d(l), L(F, h);
    }, O = (l = !1, h) => {
      d(l), L(b, h);
    }, d = (l) => {
      l || a("reset-flow");
    }, Y = (l, h) => {
      n.arrowNavigation && (_.value[h] = Re(l), M(_.value, "monthYear"));
    }, Z = z(() => {
      var l, h;
      return [
        {
          type: Qe.month,
          index: 1,
          toggle: ne,
          modelValue: ae.value,
          updateModelValue: (s) => ae.value = s,
          text: E.value.text,
          showSelectionGrid: F.value,
          items: f.value,
          ariaLabel: (l = i.value) == null ? void 0 : l.openMonthsOverlay
        },
        {
          type: Qe.year,
          index: 2,
          toggle: O,
          modelValue: V.value,
          updateModelValue: (s) => V.value = s,
          text: n.year,
          showSelectionGrid: b.value,
          items: w.value,
          ariaLabel: (h = i.value) == null ? void 0 : h.openYearsOverlay
        }
      ];
    }), y = z(() => n.disableYearSelect ? [Z.value[0]] : n.yearFirst ? [...Z.value].reverse() : Z.value);
    return t({
      toggleMonthPicker: ne,
      toggleYearPicker: O,
      handleMonthYearChange: C
    }), (l, h) => {
      var s, J, de;
      return k(), H("div", to, [
        l.$slots["month-year"] ? re(l.$slots, "month-year", _e(Ne({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: v(q), handleMonthYearChange: v(C), instance: e.instance }))) : (k(), H(ye, { key: 1 }, [
          v(g)(v(c), e.instance) && !l.vertical ? (k(), pe(It, {
            key: 0,
            "aria-label": (s = v(i)) == null ? void 0 : s.prevMonth,
            disabled: v(A)(!1),
            onActivate: h[0] || (h[0] = ($) => v(C)(!1, !0)),
            onSetRef: h[1] || (h[1] = ($) => Y($, 0))
          }, {
            default: ge(() => [
              l.$slots["arrow-left"] ? re(l.$slots, "arrow-left", { key: 0 }) : j("", !0),
              l.$slots["arrow-left"] ? j("", !0) : (k(), pe(v(En), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : j("", !0),
          fe("div", {
            class: we(["dp__month_year_wrap", {
              dp__year_disable_select: l.disableYearSelect
            }])
          }, [
            (k(!0), H(ye, null, Ae(y.value, ($, u) => (k(), H(ye, {
              key: $.type
            }, [
              fe("button", {
                ref_for: !0,
                ref: (I) => Y(I, u + 1),
                type: "button",
                class: "dp__btn dp__month_year_select",
                tabindex: "0",
                "aria-label": $.ariaLabel,
                onClick: $.toggle,
                onKeydown: [
                  ce(De($.toggle, ["prevent"]), ["enter"]),
                  ce(De($.toggle, ["prevent"]), ["space"])
                ]
              }, [
                l.$slots[$.type] ? re(l.$slots, $.type, {
                  key: 0,
                  text: $.text,
                  value: n[$.type]
                }) : j("", !0),
                l.$slots[$.type] ? j("", !0) : (k(), H(ye, { key: 1 }, [
                  st(Be($.text), 1)
                ], 64))
              ], 40, no),
              Ge(Rt, {
                name: v(R)($.showSelectionGrid),
                css: v(P)
              }, {
                default: ge(() => [
                  $.showSelectionGrid ? (k(), pe(zt, {
                    key: 0,
                    items: $.items,
                    "arrow-navigation": l.arrowNavigation,
                    "hide-navigation": l.hideNavigation,
                    "is-last": l.autoApply && !v(T).keepActionRow,
                    "skip-button-ref": !1,
                    config: l.config,
                    type: $.type,
                    "header-refs": [],
                    "esc-close": l.escClose,
                    "text-input": l.textInput,
                    onSelected: $.updateModelValue,
                    onToggle: $.toggle
                  }, Ue({
                    "button-icon": ge(() => [
                      l.$slots["calendar-icon"] ? re(l.$slots, "calendar-icon", { key: 0 }) : j("", !0),
                      l.$slots["calendar-icon"] ? j("", !0) : (k(), pe(v(Ot), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    l.$slots[`${$.type}-overlay-value`] ? {
                      name: "item",
                      fn: ge(({ item: I }) => [
                        re(l.$slots, `${$.type}-overlay-value`, {
                          text: I.text,
                          value: I.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    l.$slots[`${$.type}-overlay`] ? {
                      name: "overlay",
                      fn: ge(() => [
                        re(l.$slots, `${$.type}-overlay`, _e(Le(ie.value($.type))))
                      ]),
                      key: "1"
                    } : void 0,
                    l.$slots[`${$.type}-overlay-header`] ? {
                      name: "header",
                      fn: ge(() => [
                        re(l.$slots, `${$.type}-overlay-header`, {
                          toggle: $.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : j("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          v(g)(v(c), e.instance) && l.vertical ? (k(), pe(It, {
            key: 1,
            "aria-label": (J = v(i)) == null ? void 0 : J.prevMonth,
            disabled: v(A)(!1),
            onActivate: h[2] || (h[2] = ($) => v(C)(!1, !0))
          }, {
            default: ge(() => [
              l.$slots["arrow-up"] ? re(l.$slots, "arrow-up", { key: 0 }) : j("", !0),
              l.$slots["arrow-up"] ? j("", !0) : (k(), pe(v(Vn), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : j("", !0),
          v(S)(v(c), e.instance) ? (k(), pe(It, {
            key: 2,
            ref: "rightIcon",
            disabled: v(A)(!0),
            "aria-label": (de = v(i)) == null ? void 0 : de.nextMonth,
            onActivate: h[3] || (h[3] = ($) => v(C)(!0, !0)),
            onSetRef: h[4] || (h[4] = ($) => Y($, l.disableYearSelect ? 2 : 3))
          }, {
            default: ge(() => [
              l.$slots[l.vertical ? "arrow-down" : "arrow-right"] ? re(l.$slots, l.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : j("", !0),
              l.$slots[l.vertical ? "arrow-down" : "arrow-right"] ? j("", !0) : (k(), pe(Nn(l.vertical ? v(Ln) : v(Fn)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label"])) : j("", !0)
        ], 64))
      ]);
    };
  }
}), ro = ["aria-label"], lo = {
  class: "dp__calendar_header",
  role: "row"
}, oo = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, so = /* @__PURE__ */ fe("div", { class: "dp__calendar_header_separator" }, null, -1), io = ["aria-label"], uo = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, co = { class: "dp__cell_inner" }, fo = ["id", "aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], vo = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...tt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, { buildMultiLevelMatrix: o } = yt(), {
      defaultedTransitions: i,
      defaultedConfig: c,
      defaultedAriaLabels: p,
      defaultedMultiCalendars: T,
      defaultedWeekNumbers: D
    } = Pe(n), R = ee(null), P = ee({
      bottom: "",
      left: "",
      transform: ""
    }), M = ee([]), C = ee(null), A = ee(!0), q = ee(""), g = ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), S = ee([]), F = ee({ left: "50%" }), b = z(() => n.calendar ? n.calendar(n.mappedDates) : n.mappedDates), _ = z(() => n.dayNames ? Array.isArray(n.dayNames) ? n.dayNames : n.dayNames(n.locale, +n.weekStart) : Hr(n.formatLocale, n.locale, +n.weekStart));
    ze(() => {
      a("mount", { cmp: "calendar", refs: M }), c.value.noSwipe || C.value && (C.value.addEventListener("touchstart", O, { passive: !1 }), C.value.addEventListener("touchend", d, { passive: !1 }), C.value.addEventListener("touchmove", Y, { passive: !1 })), n.monthChangeOnScroll && C.value && C.value.addEventListener("wheel", l, { passive: !1 });
    });
    const X = ($) => $ ? n.vertical ? "vNext" : "next" : n.vertical ? "vPrevious" : "previous", ae = ($, u) => {
      if (n.transitions) {
        const I = Fe(ot(B(), n.month, n.year));
        q.value = Ee(Fe(ot(B(), $, u)), I) ? i.value[X(!0)] : i.value[X(!1)], A.value = !1, gt(() => {
          A.value = !0;
        });
      }
    }, V = z(
      () => ({
        [n.calendarClassName]: !!n.calendarClassName
      })
    ), ie = z(() => ($) => {
      const u = Lr($);
      return {
        dp__marker_dot: u.type === "dot",
        dp__marker_line: u.type === "line"
      };
    }), E = z(() => ($) => ke($, R.value)), f = z(() => ({
      dp__calendar: !0,
      dp__calendar_next: T.value.count > 0 && n.instance !== 0
    })), w = z(() => ($) => n.hideOffsetDates ? $.current : !0), L = async ($, u, I) => {
      var Q, K;
      if (a("set-hover-date", $), (K = (Q = $.marker) == null ? void 0 : Q.tooltip) != null && K.length) {
        const te = Re(M.value[u][I]);
        if (te) {
          const { width: le, height: be } = te.getBoundingClientRect();
          R.value = $.value;
          let N = { left: `${le / 2}px` }, U = -50;
          if (await gt(), S.value[0]) {
            const { left: Me, width: G } = S.value[0].getBoundingClientRect();
            Me < 0 && (N = { left: "0" }, U = 0, F.value.left = `${le / 2}px`), window.innerWidth < Me + G && (N = { right: "0" }, U = 0, F.value.left = `${G - le / 2}px`);
          }
          P.value = {
            bottom: `${be}px`,
            ...N,
            transform: `translateX(${U}%)`
          }, a("tooltip-open", $.marker);
        }
      }
    }, ne = ($) => {
      R.value && (R.value = null, P.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", $.marker));
    }, O = ($) => {
      g.value.startX = $.changedTouches[0].screenX, g.value.startY = $.changedTouches[0].screenY;
    }, d = ($) => {
      g.value.endX = $.changedTouches[0].screenX, g.value.endY = $.changedTouches[0].screenY, Z();
    }, Y = ($) => {
      n.vertical && !n.inline && $.preventDefault();
    }, Z = () => {
      const $ = n.vertical ? "Y" : "X";
      Math.abs(g.value[`start${$}`] - g.value[`end${$}`]) > 10 && a("handle-swipe", g.value[`start${$}`] > g.value[`end${$}`] ? "right" : "left");
    }, y = ($, u, I) => {
      $ && (Array.isArray(M.value[u]) ? M.value[u][I] = $ : M.value[u] = [$]), n.arrowNavigation && o(M.value, "calendar");
    }, l = ($) => {
      n.monthChangeOnScroll && ($.preventDefault(), a("handle-scroll", $));
    }, h = ($) => D.value.type === "local" ? or($.value, { weekStartsOn: +n.weekStart }) : D.value.type === "iso" ? sr($.value) : typeof D.value.type == "function" ? D.value.type($.value) : "", s = ($) => {
      const u = $[0];
      return D.value.hideOnOffsetDates ? $.some((I) => I.current) ? h(u) : "" : h(u);
    }, J = ($, u) => {
      ft($, c.value), a("select-date", u);
    }, de = ($) => {
      ft($, c.value);
    };
    return t({ triggerTransition: ae }), ($, u) => {
      var I;
      return k(), H("div", {
        class: we(f.value)
      }, [
        fe("div", {
          ref_key: "calendarWrapRef",
          ref: C,
          role: "grid",
          class: we(V.value),
          "aria-label": (I = v(p)) == null ? void 0 : I.calendarWrap
        }, [
          (k(), H(ye, { key: 0 }, [
            fe("div", lo, [
              $.weekNumbers ? (k(), H("div", oo, Be($.weekNumName), 1)) : j("", !0),
              (k(!0), H(ye, null, Ae(_.value, (Q, K) => (k(), H("div", {
                key: K,
                class: "dp__calendar_header_item",
                role: "gridcell"
              }, [
                $.$slots["calendar-header"] ? re($.$slots, "calendar-header", {
                  key: 0,
                  day: Q,
                  index: K
                }) : j("", !0),
                $.$slots["calendar-header"] ? j("", !0) : (k(), H(ye, { key: 1 }, [
                  st(Be(Q), 1)
                ], 64))
              ]))), 128))
            ]),
            so,
            Ge(Rt, {
              name: q.value,
              css: !!$.transitions
            }, {
              default: ge(() => {
                var Q;
                return [
                  A.value ? (k(), H("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "rowgroup",
                    "aria-label": ((Q = v(p)) == null ? void 0 : Q.calendarDays) || void 0
                  }, [
                    (k(!0), H(ye, null, Ae(b.value, (K, te) => (k(), H("div", {
                      key: te,
                      class: "dp__calendar_row",
                      role: "row"
                    }, [
                      $.weekNumbers ? (k(), H("div", uo, [
                        fe("div", co, Be(s(K.days)), 1)
                      ])) : j("", !0),
                      (k(!0), H(ye, null, Ae(K.days, (le, be) => {
                        var N, U, Me;
                        return k(), H("div", {
                          id: le.value.toISOString().split("T")[0],
                          ref_for: !0,
                          ref: (G) => y(G, te, be),
                          key: be + te,
                          role: "gridcell",
                          class: "dp__calendar_item",
                          "aria-selected": le.classData.dp__active_date || le.classData.dp__range_start || le.classData.dp__range_start,
                          "aria-disabled": le.classData.dp__cell_disabled || void 0,
                          "aria-label": (U = (N = v(p)) == null ? void 0 : N.day) == null ? void 0 : U.call(N, le),
                          tabindex: "0",
                          onClick: De((G) => J(G, le), ["prevent"]),
                          onKeydown: [
                            ce((G) => $.$emit("select-date", le), ["enter"]),
                            ce((G) => $.$emit("handle-space", le), ["space"])
                          ],
                          onMouseenter: (G) => L(le, te, be),
                          onMouseleave: (G) => ne(le)
                        }, [
                          fe("div", {
                            class: we(["dp__cell_inner", le.classData])
                          }, [
                            $.$slots.day && w.value(le) ? re($.$slots, "day", {
                              key: 0,
                              day: +le.text,
                              date: le.value
                            }) : j("", !0),
                            $.$slots.day ? j("", !0) : (k(), H(ye, { key: 1 }, [
                              st(Be(le.text), 1)
                            ], 64)),
                            le.marker && w.value(le) ? (k(), H(ye, { key: 2 }, [
                              $.$slots.marker ? re($.$slots, "marker", {
                                key: 0,
                                marker: le.marker,
                                day: +le.text,
                                date: le.value
                              }) : (k(), H("div", {
                                key: 1,
                                class: we(ie.value(le.marker)),
                                style: Je(le.marker.color ? { backgroundColor: le.marker.color } : {})
                              }, null, 6))
                            ], 64)) : j("", !0),
                            E.value(le.value) ? (k(), H("div", {
                              key: 3,
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: S,
                              class: "dp__marker_tooltip",
                              style: Je(P.value)
                            }, [
                              (Me = le.marker) != null && Me.tooltip ? (k(), H("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: de
                              }, [
                                (k(!0), H(ye, null, Ae(le.marker.tooltip, (G, We) => (k(), H("div", {
                                  key: We,
                                  class: "dp__tooltip_text"
                                }, [
                                  $.$slots["marker-tooltip"] ? re($.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: G,
                                    day: le.value
                                  }) : j("", !0),
                                  $.$slots["marker-tooltip"] ? j("", !0) : (k(), H(ye, { key: 1 }, [
                                    fe("div", {
                                      class: "dp__tooltip_mark",
                                      style: Je(G.color ? { backgroundColor: G.color } : {})
                                    }, null, 4),
                                    fe("div", null, Be(G.text), 1)
                                  ], 64))
                                ]))), 128)),
                                fe("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: Je(F.value)
                                }, null, 4)
                              ])) : j("", !0)
                            ], 4)) : j("", !0)
                          ], 2)
                        ], 40, fo);
                      }), 128))
                    ]))), 128))
                  ], 8, io)) : j("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 10, ro)
      ], 2);
    };
  }
}), ha = (e) => Array.isArray(e), mo = (e, t, r, a) => {
  const n = ee([]), { modelValue: o, calendars: i, time: c } = Ut(e, t), { defaultedMultiCalendars: p, defaultedStartTime: T } = Pe(e), { validateMonthYearInRange: D, isDisabled: R, isDateRangeAllowed: P, checkMinMaxRange: M } = $t(e), { updateTimeValues: C, getSetDateTime: A, setTime: q, assignStartTime: g, validateTime: S, disabledTimesConfig: F } = ja(e, c, o, a), b = z(
    () => (m) => i.value[m] ? i.value[m].month : 0
  ), _ = z(
    () => (m) => i.value[m] ? i.value[m].year : 0
  ), X = (m, W, oe) => {
    var me, Se;
    i.value[m] || (i.value[m] = { month: 0, year: 0 }), i.value[m].month = fa(W) ? (me = i.value[m]) == null ? void 0 : me.month : W, i.value[m].year = fa(oe) ? (Se = i.value[m]) == null ? void 0 : Se.year : oe;
  }, ae = () => {
    e.autoApply && t("select-date");
  };
  mt(o, (m, W) => {
    JSON.stringify(m) !== JSON.stringify(W) && E();
  }), ze(() => {
    e.shadow || (o.value || (l(), T.value && g(T.value)), E(!0), e.focusStartDate && e.startDate && l());
  });
  const V = z(() => {
    var m;
    return (m = e.flow) != null && m.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), ie = () => {
    e.autoApply && V.value && t("auto-apply", e.partialFlow);
  }, E = (m = !1) => {
    if (o.value)
      return Array.isArray(o.value) ? (n.value = o.value, d(m)) : w(o.value, m);
    if (p.value.count && m && !e.startDate)
      return f(B(), m);
  }, f = (m, W = !1) => {
    if ((!p.value.count || !p.value.static || W) && X(0, he(m), ve(m)), p.value.count && (!p.value.solo || !o.value))
      for (let oe = 1; oe < p.value.count; oe++) {
        const me = Te(B(), { month: b.value(oe - 1), year: _.value(oe - 1) }), Se = Ta(me, { months: 1 });
        i.value[oe] = { month: he(Se), year: ve(Se) };
      }
  }, w = (m, W) => {
    f(m), q("hours", xe(m)), q("minutes", lt(m)), q("seconds", Pt(m)), p.value.count && W && y();
  }, L = (m) => {
    if (p.value.count) {
      if (p.value.solo)
        return 0;
      const W = he(m[0]), oe = he(m[1]);
      return Math.abs(oe - W) < p.value.count ? 0 : 1;
    }
    return 1;
  }, ne = (m, W) => {
    m[1] && e.showLastInRange ? f(m[L(m)], W) : f(m[0], W);
    const oe = (me, Se) => [
      me(m[0]),
      m[1] ? me(m[1]) : c[Se][1]
    ];
    q("hours", oe(xe, "hours")), q("minutes", oe(lt, "minutes")), q("seconds", oe(Pt, "seconds"));
  }, O = (m, W) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return ne(m, W);
    if (e.multiDates && W) {
      const oe = m[m.length - 1];
      return w(oe, W);
    }
  }, d = (m) => {
    const W = o.value;
    O(W, m), p.value.count && p.value.solo && y();
  }, Y = (m, W) => {
    const oe = Te(B(), { month: b.value(W), year: _.value(W) }), me = m < 0 ? kt(oe, 1) : Ft(oe, 1);
    D(he(me), ve(me), m < 0, e.preventMinMaxNavigation) && (X(W, he(me), ve(me)), t("update-month-year", { instance: W, month: he(me), year: ve(me) }), p.value.count && !p.value.solo && Z(W), r());
  }, Z = (m) => {
    for (let W = m - 1; W >= 0; W--) {
      const oe = Ft(Te(B(), { month: b.value(W + 1), year: _.value(W + 1) }), 1);
      X(W, he(oe), ve(oe));
    }
    for (let W = m + 1; W <= p.value.count - 1; W++) {
      const oe = kt(Te(B(), { month: b.value(W - 1), year: _.value(W - 1) }), 1);
      X(W, he(oe), ve(oe));
    }
  }, y = () => {
    if (Array.isArray(o.value) && o.value.length === 2) {
      const m = B(
        B(o.value[1] ? o.value[1] : kt(o.value[0], 1))
      ), [W, oe] = [he(o.value[0]), ve(o.value[0])], [me, Se] = [he(o.value[1]), ve(o.value[1])];
      (W !== me || W === me && oe !== Se) && p.value.solo && X(1, he(m), ve(m));
    } else
      o.value && !Array.isArray(o.value) && (X(0, he(o.value), ve(o.value)), f(B()));
  }, l = () => {
    e.startDate && (X(0, he(B(e.startDate)), ve(B(e.startDate))), p.value.count && Z(0));
  }, h = Kr((m, W) => {
    e.monthChangeOnScroll && Y(e.monthChangeOnScroll !== "inverse" ? -m.deltaY : m.deltaY, W);
  }, 50), s = (m, W, oe = !1) => {
    e.monthChangeOnArrows && e.vertical === oe && J(m, W);
  }, J = (m, W) => {
    Y(m === "right" ? -1 : 1, W);
  }, de = (m) => e.markers.find(
    (W) => ke(Zr(m.value), et(B(W.date), e.timezone))
  ), $ = (m, W) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [m == 0, !0];
      case "fair":
        return [m == 0 || W > m, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, u = (m, W, oe, me) => {
    if (e.sixWeeks && m.length < 6) {
      const Se = 6 - m.length, nt = (W.getDay() + 7 - me) % 7, ue = 6 - (oe.getDay() + 7 - me) % 7, [se, ht] = $(nt, ue);
      for (let Ke = 1; Ke <= Se; Ke++)
        if (ht ? !!(Ke % 2) == se : se) {
          const Gt = m[0].days[0], cn = I(bt(Gt.value, -7), he(W));
          m.unshift({ days: cn });
        } else {
          const Gt = m[m.length - 1], cn = Gt.days[Gt.days.length - 1], Ga = I(bt(cn.value, 1), he(W));
          m.push({ days: Ga });
        }
    }
    return m;
  }, I = (m, W) => {
    const oe = B(m), me = [];
    for (let Se = 0; Se < 7; Se++) {
      const nt = bt(oe, Se), x = he(nt) !== W;
      me.push({
        text: e.hideOffsetDates && x ? "" : nt.getDate(),
        value: nt,
        current: !x,
        classData: {}
      });
    }
    return me;
  }, Q = (m, W) => {
    const oe = [], me = new Date(W, m), Se = new Date(W, m + 1, 0), nt = e.weekStart, x = Da(me, { weekStartsOn: nt }), ue = (se) => {
      const ht = I(se, m);
      if (oe.push({ days: ht }), !oe[oe.length - 1].days.some(
        (Ke) => ke(Fe(Ke.value), Fe(Se))
      )) {
        const Ke = bt(se, 7);
        ue(Ke);
      }
    };
    return ue(x), u(oe, me, Se, nt);
  }, K = (m) => (o.value = xt(B(m.value), e.timezone, e.weekStart), t("date-update", m.value), ie()), te = (m) => {
    const W = vt(B(m.value), c.hours, c.minutes, je());
    t("date-update", W), e.multiDates ? Gn(W, o, e.multiDatesLimit) : o.value = W, a(), gt().then(() => {
      ie();
    });
  }, le = (m) => e.noDisabledRange ? Ia(n.value[0], m).some((oe) => R(oe)) : !1, be = () => {
    n.value = o.value ? o.value.slice() : [], n.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (n.value = []);
  }, N = (m, W) => {
    const oe = [B(m.value), bt(B(m.value), +e.autoRange)];
    P(oe) ? (W && U(m.value), n.value = oe) : t("invalid-date", m.value);
  }, U = (m) => {
    const W = he(B(m)), oe = ve(B(m));
    if (X(0, W, oe), p.value.count > 0)
      for (let me = 1; me < p.value.count; me++) {
        const Se = Qr(
          Te(B(m), { year: b.value(me - 1), month: _.value(me - 1) })
        );
        X(me, Se.month, Se.year);
      }
  }, Me = (m) => Array.isArray(o.value) && o.value.length === 2 ? e.fixedStart && (Ee(m, o.value[0]) || ke(m, o.value[0])) ? [o.value[0], m] : e.fixedEnd && (Ye(m, o.value[1]) || ke(m, o.value[1])) ? [m, o.value[1]] : (t("invalid-fixed-range", m), o.value) : [], G = (m) => {
    if (le(m.value) || !M(m.value, o.value, e.fixedStart ? 0 : 1))
      return t("invalid-date", m.value);
    n.value = Me(B(m.value));
  }, We = (m, W) => {
    if (be(), e.autoRange)
      return N(m, W);
    if (e.fixedStart || e.fixedEnd)
      return G(m);
    n.value[0] ? M(B(m.value), o.value) && !le(m.value) ? Ye(B(m.value), B(n.value[0])) ? (n.value.unshift(B(m.value)), t("range-end", n.value[0])) : (n.value[1] = B(m.value), t("range-end", n.value[1])) : (e.autoApply && t("auto-apply-invalid", m.value), t("invalid-date", m.value)) : (n.value[0] = B(m.value), t("range-start", n.value[0]));
  }, je = (m = !0) => e.enableSeconds ? Array.isArray(c.seconds) ? m ? c.seconds[0] : c.seconds[1] : c.seconds : 0, it = (m) => {
    n.value[m] = vt(
      n.value[m],
      c.hours[m],
      c.minutes[m],
      je(m !== 1)
    );
  }, Wt = () => {
    var m, W;
    n.value[0] && n.value[1] && +((m = n.value) == null ? void 0 : m[0]) > +((W = n.value) == null ? void 0 : W[1]) && (n.value.reverse(), t("range-start", n.value[0]), t("range-end", n.value[1]));
  }, jt = () => {
    n.value.length && (n.value[0] && !n.value[1] ? it(0) : (it(0), it(1), a()), Wt(), o.value = n.value.slice(), on(n.value, t, e.autoApply, e.modelAuto));
  }, sn = (m, W = !1) => {
    if (R(m.value) || !m.current && e.hideOffsetDates)
      return t("invalid-date", m.value);
    if (e.weekPicker)
      return K(m);
    if (!e.range)
      return te(m);
    ha(c.hours) && ha(c.minutes) && !e.multiDates && (We(m, W), jt());
  }, Yt = (m, W) => {
    var me;
    X(m, W.month, W.year), p.value.count && !p.value.solo && Z(m), t("update-month-year", { instance: m, month: W.month, year: W.year }), r(p.value.solo ? m : void 0);
    const oe = (me = e.flow) != null && me.length ? e.flow[e.flowStep] : void 0;
    !W.fromNav && (oe === at.month || oe === at.year) && a();
  }, Ze = (m, W) => {
    Ua({ value: m, modelValue: o, range: e.range, timezone: W ? void 0 : e.timezone }), ae(), e.multiCalendars && gt().then(() => E(!0));
  }, un = () => {
    e.range ? o.value && Array.isArray(o.value) && o.value[0] ? o.value = Ye(B(), o.value[0]) ? [B(), o.value[0]] : [o.value[0], B()] : o.value = [B()] : o.value = B(), ae();
  }, dn = () => {
    if (Array.isArray(o.value))
      if (e.multiDates) {
        const m = Kt();
        o.value[o.value.length - 1] = A(m);
      } else
        o.value = o.value.map((m, W) => m && A(m, W));
    else
      o.value = A(o.value);
    t("time-update");
  }, Kt = () => Array.isArray(o.value) && o.value.length ? o.value[o.value.length - 1] : null;
  return {
    calendars: i,
    modelValue: o,
    month: b,
    year: _,
    time: c,
    disabledTimesConfig: F,
    validateTime: S,
    getCalendarDays: Q,
    getMarker: de,
    handleScroll: h,
    handleSwipe: J,
    handleArrow: s,
    selectDate: sn,
    updateMonthYear: Yt,
    presetDate: Ze,
    selectCurrentDate: un,
    updateTime: (m, W = !0, oe = !1) => {
      C(m, W, oe, dn);
    }
  };
}, go = { key: 0 }, yo = /* @__PURE__ */ Ie({
  __name: "DatePicker",
  props: {
    ...tt
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, {
      calendars: o,
      month: i,
      year: c,
      modelValue: p,
      time: T,
      disabledTimesConfig: D,
      validateTime: R,
      getCalendarDays: P,
      getMarker: M,
      handleArrow: C,
      handleScroll: A,
      handleSwipe: q,
      selectDate: g,
      updateMonthYear: S,
      presetDate: F,
      selectCurrentDate: b,
      updateTime: _
    } = mo(n, a, y, l), X = Mt(), { setHoverDate: ae, getDayClassData: V, clearHoverDate: ie } = hl(p, n), { defaultedMultiCalendars: E } = Pe(n), f = ee([]), w = ee([]), L = ee(null), ne = qe(X, "calendar"), O = qe(X, "monthYear"), d = qe(X, "timePicker"), Y = (u) => {
      n.shadow || a("mount", u);
    };
    mt(
      o,
      () => {
        n.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const Z = z(() => (u) => P(i.value(u), c.value(u)).map((I) => ({
      ...I,
      days: I.days.map((Q) => (Q.marker = M(Q), Q.classData = V(Q), Q))
    })));
    function y(u) {
      var I;
      u || u === 0 ? (I = w.value[u]) == null || I.triggerTransition(i.value(u), c.value(u)) : w.value.forEach((Q, K) => Q.triggerTransition(i.value(K), c.value(K)));
    }
    function l() {
      a("update-flow-step");
    }
    const h = (u, I = !1) => {
      g(u, I), n.spaceConfirm && a("select-date");
    };
    return t({
      clearHoverDate: ie,
      presetDate: F,
      selectCurrentDate: b,
      toggleMonthPicker: (u, I, Q = 0) => {
        var K;
        (K = f.value[Q]) == null || K.toggleMonthPicker(u, I);
      },
      toggleYearPicker: (u, I, Q = 0) => {
        var K;
        (K = f.value[Q]) == null || K.toggleYearPicker(u, I);
      },
      toggleTimePicker: (u, I, Q) => {
        var K;
        (K = L.value) == null || K.toggleTimePicker(u, I, Q);
      },
      handleArrow: C,
      updateMonthYear: S,
      getSidebarProps: () => ({
        modelValue: p,
        month: i,
        year: c,
        time: T,
        updateTime: _,
        updateMonthYear: S,
        selectDate: g,
        presetDate: F
      })
    }), (u, I) => (k(), H(ye, null, [
      Ge(ln, {
        "multi-calendars": v(E).count
      }, {
        default: ge(({ instance: Q, index: K }) => [
          u.disableMonthYearSelect ? j("", !0) : (k(), pe(ao, Ne({
            key: 0,
            ref: (te) => {
              te && (f.value[K] = te);
            },
            months: v(_a)(u.formatLocale, u.locale, u.monthNameFormat),
            years: v(jn)(u.yearRange, u.reverseYears),
            month: v(i)(Q),
            year: v(c)(Q),
            instance: Q
          }, u.$props, {
            onMount: I[0] || (I[0] = (te) => Y(v(Dt).header)),
            onResetFlow: I[1] || (I[1] = (te) => u.$emit("reset-flow")),
            onUpdateMonthYear: (te) => v(S)(Q, te),
            onOverlayClosed: I[2] || (I[2] = (te) => u.$emit("focus-menu"))
          }), Ue({ _: 2 }, [
            Ae(v(O), (te, le) => ({
              name: te,
              fn: ge((be) => [
                re(u.$slots, te, _e(Le(be)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Ge(vo, Ne({
            ref: (te) => {
              te && (w.value[K] = te);
            },
            "mapped-dates": Z.value(Q),
            month: v(i)(Q),
            year: v(c)(Q),
            instance: Q
          }, u.$props, {
            onSelectDate: (te) => v(g)(te, Q !== 1),
            onHandleSpace: (te) => h(te, Q !== 1),
            onSetHoverDate: I[3] || (I[3] = (te) => v(ae)(te)),
            onHandleScroll: (te) => v(A)(te, Q),
            onHandleSwipe: (te) => v(q)(te, Q),
            onMount: I[4] || (I[4] = (te) => Y(v(Dt).calendar)),
            onResetFlow: I[5] || (I[5] = (te) => u.$emit("reset-flow")),
            onTooltipOpen: I[6] || (I[6] = (te) => u.$emit("tooltip-open", te)),
            onTooltipClose: I[7] || (I[7] = (te) => u.$emit("tooltip-close", te))
          }), Ue({ _: 2 }, [
            Ae(v(ne), (te, le) => ({
              name: te,
              fn: ge((be) => [
                re(u.$slots, te, _e(Le({ ...be })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars"]),
      u.enableTimePicker ? (k(), H("div", go, [
        u.$slots["time-picker"] ? re(u.$slots, "time-picker", _e(Ne({ key: 0 }, { time: v(T), updateTime: v(_) }))) : (k(), pe(Wa, Ne({
          key: 1,
          ref_key: "timePickerRef",
          ref: L
        }, u.$props, {
          hours: v(T).hours,
          minutes: v(T).minutes,
          seconds: v(T).seconds,
          "internal-model-value": u.internalModelValue,
          "disabled-times-config": v(D),
          "validate-time": v(R),
          onMount: I[8] || (I[8] = (Q) => Y(v(Dt).timePicker)),
          "onUpdate:hours": I[9] || (I[9] = (Q) => v(_)(Q)),
          "onUpdate:minutes": I[10] || (I[10] = (Q) => v(_)(Q, !1)),
          "onUpdate:seconds": I[11] || (I[11] = (Q) => v(_)(Q, !1, !0)),
          onResetFlow: I[12] || (I[12] = (Q) => u.$emit("reset-flow")),
          onOverlayClosed: I[13] || (I[13] = (Q) => u.$emit("time-picker-close")),
          onOverlayOpened: I[14] || (I[14] = (Q) => u.$emit("time-picker-open", Q)),
          onAmPmChange: I[15] || (I[15] = (Q) => u.$emit("am-pm-change", Q))
        }), Ue({ _: 2 }, [
          Ae(v(d), (Q, K) => ({
            name: Q,
            fn: ge((te) => [
              re(u.$slots, Q, _e(Le(te)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : j("", !0)
    ], 64));
  }
}), ho = (e, t) => {
  const r = ee(), { defaultedMultiCalendars: a, defaultedConfig: n, defaultedHighlight: o } = Pe(e), { modelValue: i, year: c, month: p, calendars: T } = Ut(e, t), { isDisabled: D } = $t(e), { selectYear: R, groupedYears: P, showYearPicker: M, isDisabled: C, toggleYearPicker: A, handleYearSelect: q, handleYear: g } = za({
    modelValue: i,
    multiCalendars: a,
    highlight: o,
    calendars: T,
    month: p,
    year: c,
    props: e,
    emit: t
  }), S = (f, w) => [f, w].map((L) => ct(L, "MMMM", { locale: e.formatLocale })).join("-"), F = z(() => (f) => i.value ? Array.isArray(i.value) ? i.value.some((w) => xn(f, w)) : xn(i.value, f) : !1), b = (f) => {
    if (e.range) {
      if (Array.isArray(i.value)) {
        const w = ke(f, i.value[0]) || ke(f, i.value[1]);
        return nn(i.value, r.value, f) && !w;
      }
      return !1;
    }
    return !1;
  }, _ = z(() => (f) => {
    const w = Te(/* @__PURE__ */ new Date(), { year: c.value(f) });
    return ir({
      start: ur(w),
      end: dr(w)
    }).map((L) => {
      const ne = cr(L), O = ea(L), d = D(L), Y = b(ne), Z = typeof o.value == "function" ? o.value({ quarter: ta(ne), year: ve(ne) }) : !!o.value.quarters.find(
        (y) => y.quarter === ta(ne) && y.year === ve(ne)
      );
      return {
        text: S(ne, O),
        value: ne,
        active: F.value(ne),
        highlighted: Z,
        disabled: d,
        isBetween: Y
      };
    });
  }), X = (f) => {
    Gn(f, i, e.multiDatesLimit), t("auto-apply", !0);
  }, ae = (f) => {
    const w = qn(i, f, t);
    on(w, t, e.autoApply, e.modelAuto);
  }, V = (f) => {
    i.value = f, t("auto-apply");
  };
  return {
    defaultedConfig: n,
    defaultedMultiCalendars: a,
    groupedYears: P,
    year: c,
    isDisabled: C,
    quarters: _,
    showYearPicker: M,
    modelValue: i,
    setHoverDate: (f) => {
      r.value = f;
    },
    selectYear: R,
    selectQuarter: (f, w, L) => {
      if (!L)
        return T.value[w].month = he(ea(f)), e.multiDates ? X(f) : e.range ? ae(f) : V(f);
    },
    toggleYearPicker: A,
    handleYearSelect: q,
    handleYear: g
  };
}, po = { class: "dp--quarter-items" }, bo = ["disabled", "onClick", "onMouseover"], ko = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...tt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, o = Mt(), i = qe(o, "yearMode"), {
      defaultedMultiCalendars: c,
      defaultedConfig: p,
      groupedYears: T,
      year: D,
      isDisabled: R,
      quarters: P,
      modelValue: M,
      showYearPicker: C,
      setHoverDate: A,
      selectQuarter: q,
      toggleYearPicker: g,
      handleYearSelect: S,
      handleYear: F
    } = ho(n, a);
    return t({ getSidebarProps: () => ({
      modelValue: M,
      year: D,
      selectQuarter: q,
      handleYearSelect: S,
      handleYear: F
    }) }), (_, X) => (k(), pe(ln, {
      "multi-calendars": v(c).count,
      stretch: ""
    }, {
      default: ge(({ instance: ae }) => [
        fe("div", {
          class: "dp-quarter-picker-wrap",
          style: Je({ minHeight: `${v(p).modeHeight}px` })
        }, [
          fe("div", null, [
            Ge(La, Ne(_.$props, {
              items: v(T)(ae),
              instance: ae,
              "show-year-picker": v(C)[ae],
              year: v(D)(ae),
              "is-disabled": (V) => v(R)(ae, V),
              onHandleYear: (V) => v(F)(ae, V),
              onYearSelect: (V) => v(S)(V, ae),
              onToggleYearPicker: (V) => v(g)(ae, V == null ? void 0 : V.flow, V == null ? void 0 : V.show)
            }), Ue({ _: 2 }, [
              Ae(v(i), (V, ie) => ({
                name: V,
                fn: ge((E) => [
                  re(_.$slots, V, _e(Le(E)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          fe("div", po, [
            (k(!0), H(ye, null, Ae(v(P)(ae), (V, ie) => (k(), H("div", { key: ie }, [
              fe("button", {
                type: "button",
                class: we(["dp--qr-btn", {
                  "dp--qr-btn-active": V.active,
                  "dp--qr-btn-between": V.isBetween,
                  "dp--qr-btn-disabled": V.disabled,
                  "dp--highlighted": V.highlighted
                }]),
                disabled: V.disabled,
                onClick: (E) => v(q)(V.value, ae, V.disabled),
                onMouseover: (E) => v(A)(V.value)
              }, [
                _.$slots.quarter ? re(_.$slots, "quarter", {
                  key: 0,
                  value: V.value,
                  text: V.text
                }) : (k(), H(ye, { key: 1 }, [
                  st(Be(V.text), 1)
                ], 64))
              ], 42, bo)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), wo = ["id"], Do = {
  key: 0,
  class: "dp__sidebar_left"
}, Mo = {
  key: 1,
  class: "dp--preset-dates"
}, $o = ["onClick", "onKeydown"], To = {
  key: 2,
  class: "dp__sidebar_right"
}, Ao = {
  key: 3,
  class: "dp__action_extra"
}, pa = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...rn,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) },
    noOverlayFocus: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, o = z(() => {
      const { openOnTop: N, ...U } = n;
      return {
        ...U,
        flowStep: V.value,
        noOverlayFocus: n.noOverlayFocus
      };
    }), { setMenuFocused: i, setShiftKey: c, control: p } = Va(), T = Mt(), { defaultedTextInput: D, defaultedInline: R, defaultedConfig: P } = Pe(n), M = ee(null), C = ee(0), A = ee(null), q = ee(null), g = ee(!1), S = ee(null);
    ze(() => {
      if (!n.shadow) {
        g.value = !0, F(), window.addEventListener("resize", F);
        const N = Re(A);
        if (N && !D.value.enabled && !R.value.enabled && (i(!0), L()), N) {
          const U = (Me) => {
            P.value.allowPreventDefault && Me.preventDefault(), ft(Me, P.value, !0);
          };
          N.addEventListener("pointerdown", U), N.addEventListener("mousedown", U);
        }
      }
    }), Yn(() => {
      window.removeEventListener("resize", F);
    });
    const F = () => {
      const N = Re(q);
      N && (C.value = N.getBoundingClientRect().width);
    }, { arrowRight: b, arrowLeft: _, arrowDown: X, arrowUp: ae } = yt(), { flowStep: V, updateFlowStep: ie, childMount: E, resetFlow: f } = pl(n, a, S), w = z(() => n.monthPicker ? Il : n.yearPicker ? El : n.timePicker ? eo : n.quarterPicker ? ko : yo), L = () => {
      const N = Re(A);
      N && N.focus({ preventScroll: !0 });
    }, ne = z(() => {
      var N;
      return ((N = S.value) == null ? void 0 : N.getSidebarProps()) || {};
    }), O = () => {
      n.openOnTop && a("recalculate-position");
    }, d = qe(T, "action"), Y = z(() => n.monthPicker || n.yearPicker ? qe(T, "monthYear") : n.timePicker ? qe(T, "timePicker") : qe(T, "shared")), Z = z(() => n.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), y = z(() => ({
      dp__menu_disabled: n.disabled,
      dp__menu_readonly: n.readonly
    })), l = z(
      () => ({
        dp__menu: !0,
        dp__menu_index: !R.value.enabled,
        dp__relative: R.value.enabled,
        [n.menuClassName]: !!n.menuClassName
      })
    ), h = (N) => {
      ft(N, P.value, !0);
    }, s = () => {
      n.escClose && a("close-picker");
    }, J = (N) => {
      if (n.arrowNavigation) {
        if (N === "up")
          return ae();
        if (N === "down")
          return X();
        if (N === "left")
          return _();
        if (N === "right")
          return b();
      } else
        N === "left" || N === "up" ? Q("handleArrow", "left", 0, N === "up") : Q("handleArrow", "right", 0, N === "down");
    }, de = (N) => {
      c(N.shiftKey), !n.disableMonthYearSelect && N.code === "Tab" && N.target.classList.contains("dp__menu") && p.value.shiftKeyInMenu && (N.preventDefault(), ft(N, P.value, !0), a("close-picker"));
    }, $ = () => {
      L(), a("time-picker-close");
    }, u = (N) => {
      var U, Me, G;
      (U = S.value) == null || U.toggleTimePicker(!1, !1), (Me = S.value) == null || Me.toggleMonthPicker(!1, !1, N), (G = S.value) == null || G.toggleYearPicker(!1, !1, N);
    }, I = (N, U = 0) => {
      var Me, G, We;
      return N === "month" ? (Me = S.value) == null ? void 0 : Me.toggleMonthPicker(!1, !0, U) : N === "year" ? (G = S.value) == null ? void 0 : G.toggleYearPicker(!1, !0, U) : N === "time" ? (We = S.value) == null ? void 0 : We.toggleTimePicker(!0, !1) : u(U);
    }, Q = (N, ...U) => {
      var Me, G;
      (Me = S.value) != null && Me[N] && ((G = S.value) == null || G[N](...U));
    }, K = () => {
      Q("selectCurrentDate");
    }, te = (N, U) => {
      Q("presetDate", N, U);
    }, le = () => {
      Q("clearHoverDate");
    };
    return t({
      updateMonthYear: (N, U) => {
        Q("updateMonthYear", N, U);
      },
      switchView: I
    }), (N, U) => {
      var Me;
      return k(), H("div", {
        id: N.uid ? `dp-menu-${N.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: A,
        tabindex: "0",
        role: "dialog",
        class: we(l.value),
        onMouseleave: le,
        onClick: h,
        onKeydown: [
          ce(s, ["esc"]),
          U[18] || (U[18] = ce(De((G) => J("left"), ["prevent"]), ["left"])),
          U[19] || (U[19] = ce(De((G) => J("up"), ["prevent"]), ["up"])),
          U[20] || (U[20] = ce(De((G) => J("down"), ["prevent"]), ["down"])),
          U[21] || (U[21] = ce(De((G) => J("right"), ["prevent"]), ["right"])),
          de
        ]
      }, [
        (N.disabled || N.readonly) && v(R).enabled ? (k(), H("div", {
          key: 0,
          class: we(y.value)
        }, null, 2)) : j("", !0),
        !v(R).enabled && !N.teleportCenter ? (k(), H("div", {
          key: 1,
          class: we(Z.value)
        }, null, 2)) : j("", !0),
        fe("div", {
          ref_key: "innerMenuRef",
          ref: q,
          class: we({
            dp__menu_content_wrapper: ((Me = N.presetDates) == null ? void 0 : Me.length) || !!N.$slots["left-sidebar"] || !!N.$slots["right-sidebar"]
          }),
          style: Je({ "--dp-menu-width": `${C.value}px` })
        }, [
          N.$slots["left-sidebar"] ? (k(), H("div", Do, [
            re(N.$slots, "left-sidebar", _e(Le(ne.value)))
          ])) : j("", !0),
          N.presetDates.length ? (k(), H("div", Mo, [
            (k(!0), H(ye, null, Ae(N.presetDates, (G, We) => (k(), H(ye, { key: We }, [
              G.slot ? re(N.$slots, G.slot, {
                key: 0,
                presetDate: te,
                label: G.label,
                value: G.value
              }) : (k(), H("button", {
                key: 1,
                type: "button",
                style: Je(G.style || {}),
                class: "dp__btn dp--preset-range",
                onClick: De((je) => te(G.value, G.noTz), ["prevent"]),
                onKeydown: [
                  ce(De((je) => te(G.value, G.noTz), ["prevent"]), ["enter"]),
                  ce(De((je) => te(G.value, G.noTz), ["prevent"]), ["space"])
                ]
              }, Be(G.label), 45, $o))
            ], 64))), 128))
          ])) : j("", !0),
          fe("div", {
            ref_key: "calendarWrapperRef",
            ref: M,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (k(), pe(Nn(w.value), Ne({
              ref_key: "dynCmpRef",
              ref: S
            }, o.value, {
              "flow-step": v(V),
              onMount: v(E),
              onUpdateFlowStep: v(ie),
              onResetFlow: v(f),
              onFocusMenu: L,
              onSelectDate: U[0] || (U[0] = (G) => N.$emit("select-date")),
              onDateUpdate: U[1] || (U[1] = (G) => N.$emit("date-update", G)),
              onTooltipOpen: U[2] || (U[2] = (G) => N.$emit("tooltip-open", G)),
              onTooltipClose: U[3] || (U[3] = (G) => N.$emit("tooltip-close", G)),
              onAutoApply: U[4] || (U[4] = (G) => N.$emit("auto-apply", G)),
              onRangeStart: U[5] || (U[5] = (G) => N.$emit("range-start", G)),
              onRangeEnd: U[6] || (U[6] = (G) => N.$emit("range-end", G)),
              onInvalidFixedRange: U[7] || (U[7] = (G) => N.$emit("invalid-fixed-range", G)),
              onTimeUpdate: U[8] || (U[8] = (G) => N.$emit("time-update")),
              onAmPmChange: U[9] || (U[9] = (G) => N.$emit("am-pm-change", G)),
              onTimePickerOpen: U[10] || (U[10] = (G) => N.$emit("time-picker-open", G)),
              onTimePickerClose: $,
              onRecalculatePosition: O,
              onUpdateMonthYear: U[11] || (U[11] = (G) => N.$emit("update-month-year", G)),
              onAutoApplyInvalid: U[12] || (U[12] = (G) => N.$emit("auto-apply-invalid", G)),
              onInvalidDate: U[13] || (U[13] = (G) => N.$emit("invalid-date", G)),
              "onUpdate:internalModelValue": U[14] || (U[14] = (G) => N.$emit("update:internal-model-value", G))
            }), Ue({ _: 2 }, [
              Ae(Y.value, (G, We) => ({
                name: G,
                fn: ge((je) => [
                  re(N.$slots, G, _e(Le({ ...je })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          N.$slots["right-sidebar"] ? (k(), H("div", To, [
            re(N.$slots, "right-sidebar", _e(Le(ne.value)))
          ])) : j("", !0),
          N.$slots["action-extra"] ? (k(), H("div", Ao, [
            N.$slots["action-extra"] ? re(N.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: K
            }) : j("", !0)
          ])) : j("", !0)
        ], 6),
        !N.autoApply || v(P).keepActionRow ? (k(), pe(Al, Ne({
          key: 2,
          "menu-mount": g.value
        }, o.value, {
          "calendar-width": C.value,
          onClosePicker: U[15] || (U[15] = (G) => N.$emit("close-picker")),
          onSelectDate: U[16] || (U[16] = (G) => N.$emit("select-date")),
          onInvalidSelect: U[17] || (U[17] = (G) => N.$emit("invalid-select")),
          onSelectNow: K
        }), Ue({ _: 2 }, [
          Ae(v(d), (G, We) => ({
            name: G,
            fn: ge((je) => [
              re(N.$slots, G, _e(Le({ ...je })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : j("", !0)
      ], 42, wo);
    };
  }
}), So = typeof window < "u" ? window : void 0, $n = () => {
}, Po = (e) => Qa() ? (Xa(e), !0) : !1, Co = (e, t, r, a) => {
  if (!e)
    return $n;
  let n = $n;
  const o = mt(
    () => v(e),
    (c) => {
      n(), c && (c.addEventListener(t, r, a), n = () => {
        c.removeEventListener(t, r, a), n = $n;
      });
    },
    { immediate: !0, flush: "post" }
  ), i = () => {
    o(), n();
  };
  return Po(i), i;
}, _o = (e, t, r, a = {}) => {
  const { window: n = So, event: o = "pointerdown" } = a;
  return n ? Co(n, o, (c) => {
    const p = Re(e), T = Re(t);
    !p || !T || p === c.target || c.composedPath().includes(p) || c.composedPath().includes(T) || r(c);
  }, { passive: !0 }) : void 0;
}, Ro = /* @__PURE__ */ Ie({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...rn
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, o = Mt(), i = ee(!1), c = en(n, "modelValue"), p = en(n, "timezone"), T = ee(null), D = ee(null), R = ee(null), P = ee(!1), M = ee(null), C = ee(!1), A = ee(!1), { setMenuFocused: q, setShiftKey: g } = Va(), { clearArrowNav: S } = yt(), { mapDatesArrToMap: F, validateDate: b, isValidTime: _ } = $t(n), { defaultedTransitions: X, defaultedTextInput: ae, defaultedInline: V, defaultedConfig: ie } = Pe(n), { menuTransition: E, showTransition: f } = Lt(X);
    ze(() => {
      J(n.modelValue), gt().then(() => {
        if (!V.value.enabled) {
          const x = y(M.value);
          x == null || x.addEventListener("scroll", be), window == null || window.addEventListener("resize", N);
        }
      }), V.value.enabled && (i.value = !0), window == null || window.addEventListener("keyup", U), window == null || window.addEventListener("keydown", Me);
    });
    const w = z(() => F());
    Yn(() => {
      if (!V.value.enabled) {
        const x = y(M.value);
        x == null || x.removeEventListener("scroll", be), window == null || window.removeEventListener("resize", N);
      }
      window == null || window.removeEventListener("keyup", U), window == null || window.removeEventListener("keydown", Me);
    });
    const L = qe(o, "all", n.presetDates), ne = qe(o, "input");
    mt(
      [c, p],
      () => {
        J(c.value);
      },
      { deep: !0 }
    );
    const { openOnTop: O, menuStyle: d, xCorrect: Y, setMenuPosition: Z, getScrollableParent: y, shadowRender: l } = ml({
      menuRef: T,
      menuRefInner: D,
      inputRef: R,
      pickerWrapperRef: M,
      inline: V,
      emit: a,
      props: n,
      slots: o
    }), {
      inputValue: h,
      internalModelValue: s,
      parseExternalModelValue: J,
      emitModelValue: de,
      formatInputValue: $,
      checkBeforeEmit: u
    } = fl(a, n, P), I = z(
      () => ({
        dp__main: !0,
        dp__theme_dark: n.dark,
        dp__theme_light: !n.dark,
        dp__flex_display: V.value.enabled,
        dp__flex_display_with_input: V.value.input
      })
    ), Q = z(() => n.dark ? "dp__theme_dark" : "dp__theme_light"), K = z(() => ({
      to: typeof n.teleport == "boolean" ? "body" : n.teleport,
      disabled: !n.teleport || V.value.enabled
    })), te = z(() => ({ class: "dp__outer_menu_wrap" })), le = z(() => V.value.enabled && (n.timePicker || n.monthPicker || n.yearPicker || n.quarterPicker)), be = () => {
      i.value && (ie.value.closeOnScroll ? Ze() : Z());
    }, N = () => {
      i.value && Z();
    }, U = (x) => {
      x.key === "Tab" && !V.value.enabled && !n.teleport && ie.value.tabOutClosesMenu && (M.value.contains(document.activeElement) || Ze()), A.value = x.shiftKey;
    }, Me = (x) => {
      A.value = x.shiftKey;
    }, G = () => {
      !n.disabled && !n.readonly && (l(pa, n), Z(!1), i.value = !0, i.value && a("open"), i.value || Yt(), J(n.modelValue));
    }, We = () => {
      var x;
      h.value = "", Yt(), (x = R.value) == null || x.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), ie.value.closeOnClearValue && Ze();
    }, je = () => {
      const x = s.value;
      return !x || !Array.isArray(x) && b(x) ? !0 : Array.isArray(x) ? n.multiDates || x.length === 2 && b(x[0]) && b(x[1]) ? !0 : n.partialRange && !n.timePicker ? b(x[0]) : !1 : !1;
    }, it = () => {
      u() && je() ? (de(), Ze()) : a("invalid-select", s.value);
    }, Wt = (x) => {
      jt(), de(), ie.value.closeOnAutoApply && !x && Ze();
    }, jt = () => {
      R.value && ae.value.enabled && R.value.setParsedDate(s.value);
    }, sn = (x = !1) => {
      n.autoApply && _(s.value) && je() && (n.range && Array.isArray(s.value) ? (n.partialRange || s.value.length === 2) && Wt(x) : Wt(x));
    }, Yt = () => {
      ae.value.enabled || (s.value = null);
    }, Ze = () => {
      V.value.enabled || (i.value && (i.value = !1, Y.value = !1, q(!1), g(!1), S(), a("closed"), h.value && J(c.value)), Yt(), a("blur"));
    }, un = (x, ue, se = !1) => {
      if (!x) {
        s.value = null;
        return;
      }
      const ht = Array.isArray(x) ? !x.some((Qn) => !b(Qn)) : b(x), Ke = _(x);
      ht && Ke && (s.value = x, ue && (C.value = se, it(), a("text-submit")));
    }, dn = () => {
      n.autoApply && _(s.value) && de(), jt();
    }, Kt = () => i.value ? Ze() : G(), Zn = (x) => {
      s.value = x;
    }, m = () => {
      ae.value.enabled && (P.value = !0, $()), a("focus");
    }, W = () => {
      if (ae.value.enabled && (P.value = !1, J(n.modelValue), C.value)) {
        const x = jr(M.value, A.value);
        x == null || x.focus();
      }
      a("blur");
    }, oe = (x) => {
      D.value && D.value.updateMonthYear(0, {
        month: ca(x.month),
        year: ca(x.year)
      });
    }, me = (x) => {
      J(x ?? n.modelValue);
    }, Se = (x, ue) => {
      var se;
      (se = D.value) == null || se.switchView(x, ue);
    }, nt = (x) => ie.value.onClickOutside ? ie.value.onClickOutside(x) : Ze();
    return _o(T, R, () => nt(je)), t({
      closeMenu: Ze,
      selectDate: it,
      clearValue: We,
      openMenu: G,
      onScroll: be,
      formatInputValue: $,
      // exposed for testing purposes
      updateInternalModelValue: Zn,
      // modify internal modelValue
      setMonthYear: oe,
      parseModel: me,
      switchView: Se,
      toggleMenu: Kt
    }), (x, ue) => (k(), H("div", {
      ref_key: "pickerWrapperRef",
      ref: M,
      class: we(I.value),
      "data-datepicker-instance": ""
    }, [
      Ge(Dl, Ne({
        ref_key: "inputRef",
        ref: R,
        "input-value": v(h),
        "onUpdate:inputValue": ue[0] || (ue[0] = (se) => Jn(h) ? h.value = se : null),
        "is-menu-open": i.value
      }, x.$props, {
        onClear: We,
        onOpen: G,
        onSetInputDate: un,
        onSetEmptyDate: v(de),
        onSelectDate: it,
        onToggle: Kt,
        onClose: Ze,
        onFocus: m,
        onBlur: W,
        onRealBlur: ue[1] || (ue[1] = (se) => P.value = !1)
      }), Ue({ _: 2 }, [
        Ae(v(ne), (se, ht) => ({
          name: se,
          fn: ge((Ke) => [
            re(x.$slots, se, _e(Le(Ke)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      Ge(Ja, _e(Le(K.value)), {
        default: ge(() => [
          Ge(Rt, {
            name: v(E)(v(O)),
            css: v(f) && !v(V).enabled
          }, {
            default: ge(() => [
              i.value ? (k(), H("div", Ne({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: T
              }, te.value, {
                class: { "dp--menu-wrapper": !v(V).enabled },
                style: v(V).enabled ? void 0 : v(d)
              }), [
                Ge(pa, Ne({
                  ref_key: "dpMenuRef",
                  ref: D
                }, x.$props, {
                  "internal-model-value": v(s),
                  "onUpdate:internalModelValue": ue[2] || (ue[2] = (se) => Jn(s) ? s.value = se : null),
                  class: { [Q.value]: !0, "dp--menu-wrapper": x.teleport },
                  "open-on-top": v(O),
                  "arr-map-values": w.value,
                  "no-overlay-focus": le.value,
                  onClosePicker: Ze,
                  onSelectDate: it,
                  onAutoApply: sn,
                  onTimeUpdate: dn,
                  onFlowStep: ue[3] || (ue[3] = (se) => x.$emit("flow-step", se)),
                  onUpdateMonthYear: ue[4] || (ue[4] = (se) => x.$emit("update-month-year", se)),
                  onInvalidSelect: ue[5] || (ue[5] = (se) => x.$emit("invalid-select", v(s))),
                  onAutoApplyInvalid: ue[6] || (ue[6] = (se) => x.$emit("invalid-select", se)),
                  onInvalidFixedRange: ue[7] || (ue[7] = (se) => x.$emit("invalid-fixed-range", se)),
                  onRecalculatePosition: v(Z),
                  onTooltipOpen: ue[8] || (ue[8] = (se) => x.$emit("tooltip-open", se)),
                  onTooltipClose: ue[9] || (ue[9] = (se) => x.$emit("tooltip-close", se)),
                  onTimePickerOpen: ue[10] || (ue[10] = (se) => x.$emit("time-picker-open", se)),
                  onTimePickerClose: ue[11] || (ue[11] = (se) => x.$emit("time-picker-close", se)),
                  onAmPmChange: ue[12] || (ue[12] = (se) => x.$emit("am-pm-change", se)),
                  onRangeStart: ue[13] || (ue[13] = (se) => x.$emit("range-start", se)),
                  onRangeEnd: ue[14] || (ue[14] = (se) => x.$emit("range-end", se)),
                  onDateUpdate: ue[15] || (ue[15] = (se) => x.$emit("date-update", se)),
                  onInvalidDate: ue[16] || (ue[16] = (se) => x.$emit("invalid-date", se))
                }), Ue({ _: 2 }, [
                  Ae(v(L), (se, ht) => ({
                    name: se,
                    fn: ge((Ke) => [
                      re(x.$slots, se, _e(Le({ ...Ke })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "arr-map-values", "no-overlay-focus", "onRecalculatePosition"])
              ], 16)) : j("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Ka = /* @__PURE__ */ (() => {
  const e = Ro;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), Oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ka
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(Oo).forEach(([e, t]) => {
  e !== "default" && (Ka[e] = t);
});
export {
  Ka as default
};
